import { withNamespaces } from "react-i18next"
import Accordion from 'react-bootstrap/Accordion';
import GeneralInformationImage from "src/modules/3rd-party-management/assets/images/general-information.svg";
import { Badge, Card, CardBody, Col, Label, Row } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import LocalizedPhoneInput from "src/modules/3rd-party-management/components/LocalizedPhoneInput";
import { RiBuilding4Line, RiMapPinLine } from "react-icons/ri";

function buildNestedObject(data) {
    const result = {};

    data.forEach(({ key, value }) => {
        const keys = key.split('.');
        let current = result;

        keys.forEach((part, index) => {
            const isLast = index === keys.length - 1;
            const isArrayIndex = !isNaN(Number(part)); // check if number

            if (isLast) {
                // Set the value
                if (isArrayIndex) {
                    if (!Array.isArray(current)) current = []; // make sure current is array
                    current[Number(part)] = value;
                } else {
                    current[part] = value;
                }
            } else {
                // Prepare next level
                const nextPart = keys[index + 1];
                const nextIsArray = !isNaN(Number(nextPart));

                if (isArrayIndex) {
                    // Current should be array
                    if (!Array.isArray(current)) current = [];
                    if (!current[Number(part)]) current[Number(part)] = nextIsArray ? [] : {};
                    current = current[Number(part)];
                } else {
                    // Current should be object
                    if (!current[part]) current[part] = nextIsArray ? [] : {};
                    current = current[part];
                }
            }
        });
    });

    return result;
}

const GenericDataCol = ({ t, label, value }) => {
    return (
        <Col xs='12' md="6" className="mb-2">
            <Row className="align-items-center py-1">
                <Col xs='12' md='4' className="d-flex align-items-center">
                    <div className="fw-bold text-muted">
                        {t(label)}
                    </div>
                </Col>
                <Col xs='12' md='8' className="text-start">
                    <div className="fw-bold">
                        {value}
                    </div>
                </Col>
            </Row>
        </Col>
    )
}

const GeneralInfo = ({
    t,
    activeAccordion,
    setActiveAccordion,

    detailsQuery
}) => {
    if (detailsQuery.isFetching) {
        return (
            <Row>
                <Col 
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    const dateUtils = new DateUtils();

    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    console.log(organizationData, buildNestedObject(
        [
            {
                "key": "misc.sizeOfUrbanArea",
                "value": "Urban unit with 100 000 to  199 999 inhabitants"
            },
            {
                "key": "misc.reasonForFormation",
                "value": "Formation"
            },
            {
                "key": "misc.financialAccountsType",
                "value": "F"
            },
            {
                "key": "misc.statusCode",
                "value": "A"
            },
            {
                "key": "misc.officeType",
                "value": "1"
            },
            {
                "key": "misc.numberOfBranches",
                "value": "1"
            },
            {
                "key": "misc.numberOfEmployeesAtAddress",
                "value": "50 to 99 employees"
            },
            {
                "key": "misc.previousSiret",
                "value": "71202304300037"
            },
            {
                "key": "misc.numberOfEmployeesAtCompany",
                "value": "50 to 99 employees"
            },
            {
                "key": "misc.activityClassification",
                "value": "NAF\/APE"
            },
            {
                "key": "misc.inseeCode",
                "value": "74145"
            },
            {
                "key": "misc.streetAddress",
                "value": "269 RUE GEORGES CHARPAK"
            },
            {
                "key": "misc.postalCode",
                "value": "74100"
            },
            {
                "key": "misc.municipality",
                "value": "JUVIGNY"
            },
            {
                "key": "misc.subRegion",
                "value": "Haute-Savoie (74)"
            },
            {
                "key": "misc.numberOfCompanies",
                "value": "0"
            },
            {
                "key": "misc.courtRegistryNumber",
                "value": "712023043"
            },
            {
                "key": "misc.courtRegistryNumberAdditional",
                "value": "19 8 4B00046"
            },
            {
                "key": "misc.registrationCourt",
                "value": "Thonon-Les-Bains (74)"
            },
            {
                "key": "misc.nationality",
                "value": "France"
            },
            {
                "key": "misc.numberOfDirectors",
                "value": "2"
            },
            {
                "key": "misc.rcsRegistration",
                "value": "RCS Thonon-Les-Bains B 712 023 043"
            },
            {
                "key": "misc.workforceAccount",
                "value": "50 to 99 employees"
            },
            {
                "key": "misc.preferentialStatus",
                "value": "Stopped"
            },
            {
                "key": "misc.summaryFormationDate",
                "value": "04\/1971"
            },
            {
                "key": "misc.postalAddress",
                "value": "LABLABO, 269 RUE GEORGES CHARPAK, 74100 JUVIGNY"
            },
            {
                "key": "misc.businessPagesFt",
                "value": "FLACONNAGES"
            },
            {
                "key": "misc.headQuarterSafeNumber",
                "value": "FR16259764"
            },
            {
                "key": "misc.preferentialRightsSummaryText",
                "value": "Collection of preferential rights for this company has been stopped by the Court"
            },
            {
                "key": "trends.profitability",
                "value": "Greater"
            },
            {
                "key": "trends.liquidity",
                "value": "Greater"
            },
            {
                "key": "trends.netWorth",
                "value": "Greater"
            },
            {
                "key": "establishmentDetails.typeOfEstablishmentDescription",
                "value": "Head Office"
            },
            {
                "key": "establishmentDetails.formationDate",
                "value": "2013-01-01T00:00:00Z"
            },
            {
                "key": "establishmentDetails.department",
                "value": "Haute-Savoie (74)"
            },
            {
                "key": "establishmentDetails.district",
                "value": "3"
            },
            {
                "key": "establishmentDetails.area",
                "value": "09"
            },
            {
                "key": "establishmentDetails.tradingAddress",
                "value": "269 RUE GEORGES CHARPAK 74100 JUVIGNY"
            },
            {
                "key": "establishmentDetails.city",
                "value": "JUVIGNY"
            },
            {
                "key": "otherEstablishmentDetails.apeNafCode",
                "value": "2222Z"
            },
            {
                "key": "otherEstablishmentDetails.regionality",
                "value": "Legal unit with all establishments in same area"
            },
            {
                "key": "otherEstablishmentDetails.monoActivityStatus",
                "value": "Legal unit having all establishments with the same main activity"
            },
            {
                "key": "additionalAuditorInformation.0.name",
                "value": "ERNST & YOUNG ET AUTRES"
            },
            {
                "key": "additionalAuditorInformation.0.gender",
                "value": "Unknown"
            },
            {
                "key": "additionalAuditorInformation.0.directorType",
                "value": "Other"
            },
            {
                "key": "additionalAuditorInformation.0.positions.0.positionName",
                "value": "Statutory auditor"
            },
            {
                "key": "additionalAuditorInformation.0.additionalData.pnr",
                "value": "7120230431"
            },
            {
                "key": "additionalAuditorInformation.0.additionalData.sk",
                "value": "1400712023043ERNST & YOUNG ET AUTRES"
            },
            {
                "key": "additionalAuditorInformation.0.auditorType",
                "value": "Company"
            },
            {
                "key": "additionalAuditorInformation.0.type",
                "value": "Corporation"
            },
            {
                "key": "exposureIndicator.companyExposure",
                "value": "0"
            },
            {
                "key": "exposureIndicator.activityExposure",
                "value": "B"
            },
            {
                "key": "exposureIndicator.activitySector",
                "value": "Manufacture of plastic packing goods"
            },
            {
                "key": "exposureIndicator.activityLoss",
                "value": "17"
            },
            {
                "key": "companyHistory.0.date",
                "value": "2024-10-31T00:00:00Z"
            },
            {
                "key": "companyHistory.0.description",
                "value": "Bodacc B : Administration updated"
            },
            {
                "key": "companyHistory.1.date",
                "value": "2024-10-30T00:00:00Z"
            },
            {
                "key": "companyHistory.1.description",
                "value": "Indicator of financial exposure to COVID_19 crisis change"
            },
            {
                "key": "companyHistory.2.date",
                "value": "2024-10-30T00:00:00Z"
            },
            {
                "key": "companyHistory.2.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.3.date",
                "value": "2024-10-30T00:00:00Z"
            },
            {
                "key": "companyHistory.3.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.4.date",
                "value": "2024-10-24T00:00:00Z"
            },
            {
                "key": "companyHistory.4.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.5.date",
                "value": "2024-09-26T00:00:00Z"
            },
            {
                "key": "companyHistory.5.description",
                "value": "Change of directors"
            },
            {
                "key": "companyHistory.6.date",
                "value": "2022-09-24T00:00:00Z"
            },
            {
                "key": "companyHistory.6.description",
                "value": "Indicator of financial exposure to COVID_19 crisis change"
            },
            {
                "key": "companyHistory.7.date",
                "value": "2022-09-24T00:00:00Z"
            },
            {
                "key": "companyHistory.7.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.8.date",
                "value": "2021-09-25T00:00:00Z"
            },
            {
                "key": "companyHistory.8.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.9.date",
                "value": "2021-09-25T00:00:00Z"
            },
            {
                "key": "companyHistory.9.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.10.date",
                "value": "2021-05-20T00:00:00Z"
            },
            {
                "key": "companyHistory.10.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.11.date",
                "value": "2021-05-10T00:00:00Z"
            },
            {
                "key": "companyHistory.11.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.12.date",
                "value": "2019-11-26T00:00:00Z"
            },
            {
                "key": "companyHistory.12.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.13.date",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "companyHistory.13.description",
                "value": "New legal form \u2013 new category"
            },
            {
                "key": "companyHistory.14.date",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "companyHistory.14.description",
                "value": "New closing date"
            },
            {
                "key": "companyHistory.15.date",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "companyHistory.15.description",
                "value": "New chairman (CEO, CoB)"
            },
            {
                "key": "companyHistory.16.date",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "companyHistory.16.description",
                "value": "New auditor"
            },
            {
                "key": "companyHistory.17.date",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "companyHistory.17.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.18.date",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "companyHistory.18.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.19.date",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "companyHistory.19.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.20.date",
                "value": "2019-11-13T00:00:00Z"
            },
            {
                "key": "companyHistory.20.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.21.date",
                "value": "2019-11-05T00:00:00Z"
            },
            {
                "key": "companyHistory.21.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.22.date",
                "value": "2019-11-05T00:00:00Z"
            },
            {
                "key": "companyHistory.22.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.23.date",
                "value": "2019-10-31T00:00:00Z"
            },
            {
                "key": "companyHistory.23.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.24.date",
                "value": "2019-10-31T00:00:00Z"
            },
            {
                "key": "companyHistory.24.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.25.date",
                "value": "2019-10-28T00:00:00Z"
            },
            {
                "key": "companyHistory.25.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.26.date",
                "value": "2019-10-28T00:00:00Z"
            },
            {
                "key": "companyHistory.26.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.27.date",
                "value": "2019-09-24T00:00:00Z"
            },
            {
                "key": "companyHistory.27.description",
                "value": "Legal Gazette: Change of legal form"
            },
            {
                "key": "companyHistory.28.date",
                "value": "2019-09-24T00:00:00Z"
            },
            {
                "key": "companyHistory.28.description",
                "value": "Change of directors"
            },
            {
                "key": "companyHistory.29.date",
                "value": "2019-09-24T00:00:00Z"
            },
            {
                "key": "companyHistory.29.description",
                "value": "Administrator appointed"
            },
            {
                "key": "companyHistory.30.date",
                "value": "2019-08-01T00:00:00Z"
            },
            {
                "key": "companyHistory.30.description",
                "value": "Change of directors"
            },
            {
                "key": "companyHistory.31.date",
                "value": "2019-08-01T00:00:00Z"
            },
            {
                "key": "companyHistory.31.description",
                "value": "Administrator appointed"
            },
            {
                "key": "companyHistory.32.date",
                "value": "2019-07-02T00:00:00Z"
            },
            {
                "key": "companyHistory.32.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.33.date",
                "value": "2019-07-02T00:00:00Z"
            },
            {
                "key": "companyHistory.33.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.34.date",
                "value": "2019-07-02T00:00:00Z"
            },
            {
                "key": "companyHistory.34.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.35.date",
                "value": "2019-06-20T00:00:00Z"
            },
            {
                "key": "companyHistory.35.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.36.date",
                "value": "2019-04-05T00:00:00Z"
            },
            {
                "key": "companyHistory.36.description",
                "value": "Collection of preferential rights activated for this company"
            },
            {
                "key": "companyHistory.37.date",
                "value": "2018-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.37.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.38.date",
                "value": "2018-07-25T00:00:00Z"
            },
            {
                "key": "companyHistory.38.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.39.date",
                "value": "2018-07-14T00:00:00Z"
            },
            {
                "key": "companyHistory.39.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.40.date",
                "value": "2018-07-14T00:00:00Z"
            },
            {
                "key": "companyHistory.40.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.41.date",
                "value": "2018-03-24T00:00:00Z"
            },
            {
                "key": "companyHistory.41.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.42.date",
                "value": "2018-03-24T00:00:00Z"
            },
            {
                "key": "companyHistory.42.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.43.date",
                "value": "2018-02-02T00:00:00Z"
            },
            {
                "key": "companyHistory.43.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.44.date",
                "value": "2018-01-18T00:00:00Z"
            },
            {
                "key": "companyHistory.44.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.45.date",
                "value": "2018-01-18T00:00:00Z"
            },
            {
                "key": "companyHistory.45.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.46.date",
                "value": "2018-01-16T00:00:00Z"
            },
            {
                "key": "companyHistory.46.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.47.date",
                "value": "2018-01-16T00:00:00Z"
            },
            {
                "key": "companyHistory.47.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.48.date",
                "value": "2017-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.48.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.49.date",
                "value": "2017-11-12T00:00:00Z"
            },
            {
                "key": "companyHistory.49.description",
                "value": "Legal Gazette: Appointment of the social representative"
            },
            {
                "key": "companyHistory.50.date",
                "value": "2017-08-29T00:00:00Z"
            },
            {
                "key": "companyHistory.50.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.51.date",
                "value": "2017-08-03T00:00:00Z"
            },
            {
                "key": "companyHistory.51.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.52.date",
                "value": "2017-08-03T00:00:00Z"
            },
            {
                "key": "companyHistory.52.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.53.date",
                "value": "2017-08-03T00:00:00Z"
            },
            {
                "key": "companyHistory.53.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.54.date",
                "value": "2017-04-06T00:00:00Z"
            },
            {
                "key": "companyHistory.54.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.55.date",
                "value": "2017-04-06T00:00:00Z"
            },
            {
                "key": "companyHistory.55.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.56.date",
                "value": "2017-04-06T00:00:00Z"
            },
            {
                "key": "companyHistory.56.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.57.date",
                "value": "2017-03-24T00:00:00Z"
            },
            {
                "key": "companyHistory.57.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.58.date",
                "value": "2016-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.58.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.59.date",
                "value": "2016-12-11T00:00:00Z"
            },
            {
                "key": "companyHistory.59.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.60.date",
                "value": "2016-12-11T00:00:00Z"
            },
            {
                "key": "companyHistory.60.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.61.date",
                "value": "2016-01-13T00:00:00Z"
            },
            {
                "key": "companyHistory.61.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.62.date",
                "value": "2015-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.62.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.63.date",
                "value": "2015-11-28T00:00:00Z"
            },
            {
                "key": "companyHistory.63.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.64.date",
                "value": "2015-11-28T00:00:00Z"
            },
            {
                "key": "companyHistory.64.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.65.date",
                "value": "2015-11-26T00:00:00Z"
            },
            {
                "key": "companyHistory.65.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.66.date",
                "value": "2015-11-26T00:00:00Z"
            },
            {
                "key": "companyHistory.66.description",
                "value": "Appointment\/resignation of company officers"
            },
            {
                "key": "companyHistory.67.date",
                "value": "2015-11-06T00:00:00Z"
            },
            {
                "key": "companyHistory.67.description",
                "value": "Legal Gazette: Appointment of the social representative"
            },
            {
                "key": "companyHistory.68.date",
                "value": "2015-10-03T00:00:00Z"
            },
            {
                "key": "companyHistory.68.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.69.date",
                "value": "2015-10-03T00:00:00Z"
            },
            {
                "key": "companyHistory.69.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.70.date",
                "value": "2015-10-03T00:00:00Z"
            },
            {
                "key": "companyHistory.70.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.71.date",
                "value": "2015-10-03T00:00:00Z"
            },
            {
                "key": "companyHistory.71.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.72.date",
                "value": "2015-01-01T00:00:00Z"
            },
            {
                "key": "companyHistory.72.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.73.date",
                "value": "2015-01-01T00:00:00Z"
            },
            {
                "key": "companyHistory.73.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.74.date",
                "value": "2015-01-01T00:00:00Z"
            },
            {
                "key": "companyHistory.74.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.75.date",
                "value": "2014-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.75.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.76.date",
                "value": "2014-12-13T00:00:00Z"
            },
            {
                "key": "companyHistory.76.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.77.date",
                "value": "2014-02-08T00:00:00Z"
            },
            {
                "key": "companyHistory.77.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.78.date",
                "value": "2014-02-08T00:00:00Z"
            },
            {
                "key": "companyHistory.78.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.79.date",
                "value": "2013-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.79.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.80.date",
                "value": "2013-10-19T00:00:00Z"
            },
            {
                "key": "companyHistory.80.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.81.date",
                "value": "2013-10-19T00:00:00Z"
            },
            {
                "key": "companyHistory.81.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.82.date",
                "value": "2013-08-27T00:00:00Z"
            },
            {
                "key": "companyHistory.82.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.83.date",
                "value": "2013-08-13T00:00:00Z"
            },
            {
                "key": "companyHistory.83.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.84.date",
                "value": "2013-08-13T00:00:00Z"
            },
            {
                "key": "companyHistory.84.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.85.date",
                "value": "2013-07-18T00:00:00Z"
            },
            {
                "key": "companyHistory.85.description",
                "value": "Update Limit"
            },
            {
                "key": "companyHistory.86.date",
                "value": "2013-07-18T00:00:00Z"
            },
            {
                "key": "companyHistory.86.description",
                "value": "Update Rating"
            },
            {
                "key": "companyHistory.87.date",
                "value": "2013-02-06T00:00:00Z"
            },
            {
                "key": "companyHistory.87.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.88.date",
                "value": "2013-01-22T00:00:00Z"
            },
            {
                "key": "companyHistory.88.description",
                "value": "Registered office transferred inside jurisdiction of the Commercial Court"
            },
            {
                "key": "companyHistory.89.date",
                "value": "2013-01-22T00:00:00Z"
            },
            {
                "key": "companyHistory.89.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.90.date",
                "value": "2013-01-22T00:00:00Z"
            },
            {
                "key": "companyHistory.90.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.91.date",
                "value": "2013-01-07T00:00:00Z"
            },
            {
                "key": "companyHistory.91.description",
                "value": "Legal Gazette: Head Office Transfer"
            },
            {
                "key": "companyHistory.92.date",
                "value": "2013-01-02T00:00:00Z"
            },
            {
                "key": "companyHistory.92.description",
                "value": "Transfer of Establishment"
            },
            {
                "key": "companyHistory.93.date",
                "value": "2013-01-02T00:00:00Z"
            },
            {
                "key": "companyHistory.93.description",
                "value": "Update of Company Head Office Identifier"
            },
            {
                "key": "companyHistory.94.date",
                "value": "2012-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.94.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.95.date",
                "value": "2012-08-21T00:00:00Z"
            },
            {
                "key": "companyHistory.95.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.96.date",
                "value": "2012-07-31T00:00:00Z"
            },
            {
                "key": "companyHistory.96.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.97.date",
                "value": "2011-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.97.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.98.date",
                "value": "2011-09-13T00:00:00Z"
            },
            {
                "key": "companyHistory.98.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.99.date",
                "value": "2011-09-04T00:00:00Z"
            },
            {
                "key": "companyHistory.99.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.100.date",
                "value": "2011-08-26T00:00:00Z"
            },
            {
                "key": "companyHistory.100.description",
                "value": "Consideration of a balance sheet that has led to a reassessment of this company's creditworthiness"
            },
            {
                "key": "companyHistory.101.date",
                "value": "2011-08-11T00:00:00Z"
            },
            {
                "key": "companyHistory.101.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.102.date",
                "value": "2011-08-11T00:00:00Z"
            },
            {
                "key": "companyHistory.102.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.103.date",
                "value": "2011-07-21T00:00:00Z"
            },
            {
                "key": "companyHistory.103.description",
                "value": "Legal Gazette: Resignation \/ Revocation of the social representative"
            },
            {
                "key": "companyHistory.104.date",
                "value": "2011-06-23T00:00:00Z"
            },
            {
                "key": "companyHistory.104.description",
                "value": "Legal Gazette: Appointment of the social representative"
            },
            {
                "key": "companyHistory.105.date",
                "value": "2010-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.105.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.106.date",
                "value": "2010-09-14T00:00:00Z"
            },
            {
                "key": "companyHistory.106.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.107.date",
                "value": "2010-08-22T00:00:00Z"
            },
            {
                "key": "companyHistory.107.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.108.date",
                "value": "2010-07-19T00:00:00Z"
            },
            {
                "key": "companyHistory.108.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.109.date",
                "value": "2010-07-19T00:00:00Z"
            },
            {
                "key": "companyHistory.109.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.110.date",
                "value": "2009-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.110.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.111.date",
                "value": "2009-11-30T00:00:00Z"
            },
            {
                "key": "companyHistory.111.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.112.date",
                "value": "2009-11-02T00:00:00Z"
            },
            {
                "key": "companyHistory.112.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.113.date",
                "value": "2009-11-02T00:00:00Z"
            },
            {
                "key": "companyHistory.113.description",
                "value": "New auditor"
            },
            {
                "key": "companyHistory.114.date",
                "value": "2009-08-26T00:00:00Z"
            },
            {
                "key": "companyHistory.114.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.115.date",
                "value": "2009-08-13T00:00:00Z"
            },
            {
                "key": "companyHistory.115.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.116.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.116.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.117.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.117.description",
                "value": "Appointment\/resignation of company officers"
            },
            {
                "key": "companyHistory.118.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.118.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.119.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.119.description",
                "value": "Minutes of Board meeting"
            },
            {
                "key": "companyHistory.120.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.120.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.121.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.121.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.122.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.122.description",
                "value": "New chairman (CEO, CoB)"
            },
            {
                "key": "companyHistory.123.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.123.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.124.date",
                "value": "2009-07-23T00:00:00Z"
            },
            {
                "key": "companyHistory.124.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.125.date",
                "value": "2009-06-24T00:00:00Z"
            },
            {
                "key": "companyHistory.125.description",
                "value": "Bodacc C : Deposit accounts notice"
            },
            {
                "key": "companyHistory.126.date",
                "value": "2008-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.126.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.127.date",
                "value": "2008-12-09T00:00:00Z"
            },
            {
                "key": "companyHistory.127.description",
                "value": "Bodacc B: Various editing or changing"
            },
            {
                "key": "companyHistory.128.date",
                "value": "2008-12-09T00:00:00Z"
            },
            {
                "key": "companyHistory.128.description",
                "value": "New Bodacc B ads detected"
            },
            {
                "key": "companyHistory.129.date",
                "value": "2008-10-07T00:00:00Z"
            },
            {
                "key": "companyHistory.129.description",
                "value": "Capital reduction"
            },
            {
                "key": "companyHistory.130.date",
                "value": "2008-10-07T00:00:00Z"
            },
            {
                "key": "companyHistory.130.description",
                "value": "Audit or Management Report"
            },
            {
                "key": "companyHistory.131.date",
                "value": "2008-10-07T00:00:00Z"
            },
            {
                "key": "companyHistory.131.description",
                "value": "Audit or Management Report"
            },
            {
                "key": "companyHistory.132.date",
                "value": "2008-10-07T00:00:00Z"
            },
            {
                "key": "companyHistory.132.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.133.date",
                "value": "2008-10-07T00:00:00Z"
            },
            {
                "key": "companyHistory.133.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.134.date",
                "value": "2008-10-07T00:00:00Z"
            },
            {
                "key": "companyHistory.134.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.135.date",
                "value": "2008-10-07T00:00:00Z"
            },
            {
                "key": "companyHistory.135.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.136.date",
                "value": "2008-10-07T00:00:00Z"
            },
            {
                "key": "companyHistory.136.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.137.date",
                "value": "2008-07-30T00:00:00Z"
            },
            {
                "key": "companyHistory.137.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.138.date",
                "value": "2008-07-30T00:00:00Z"
            },
            {
                "key": "companyHistory.138.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.139.date",
                "value": "2008-07-30T00:00:00Z"
            },
            {
                "key": "companyHistory.139.description",
                "value": "Capital reduction"
            },
            {
                "key": "companyHistory.140.date",
                "value": "2008-07-30T00:00:00Z"
            },
            {
                "key": "companyHistory.140.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.141.date",
                "value": "2007-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.141.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.142.date",
                "value": "2007-03-02T00:00:00Z"
            },
            {
                "key": "companyHistory.142.description",
                "value": "Minutes of Board meeting"
            },
            {
                "key": "companyHistory.143.date",
                "value": "2007-03-02T00:00:00Z"
            },
            {
                "key": "companyHistory.143.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.144.date",
                "value": "2007-03-02T00:00:00Z"
            },
            {
                "key": "companyHistory.144.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.145.date",
                "value": "2007-03-02T00:00:00Z"
            },
            {
                "key": "companyHistory.145.description",
                "value": "Audit or Management Report"
            },
            {
                "key": "companyHistory.146.date",
                "value": "2007-03-02T00:00:00Z"
            },
            {
                "key": "companyHistory.146.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.147.date",
                "value": "2006-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.147.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.148.date",
                "value": "2006-03-02T00:00:00Z"
            },
            {
                "key": "companyHistory.148.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.149.date",
                "value": "2006-03-02T00:00:00Z"
            },
            {
                "key": "companyHistory.149.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.150.date",
                "value": "2005-12-31T00:00:00Z"
            },
            {
                "key": "companyHistory.150.description",
                "value": "New accounts available"
            },
            {
                "key": "companyHistory.151.date",
                "value": "2005-12-01T00:00:00Z"
            },
            {
                "key": "companyHistory.151.description",
                "value": "Appointment\/resignation of company officers"
            },
            {
                "key": "companyHistory.152.date",
                "value": "2005-12-01T00:00:00Z"
            },
            {
                "key": "companyHistory.152.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.153.date",
                "value": "2005-12-01T00:00:00Z"
            },
            {
                "key": "companyHistory.153.description",
                "value": "Minutes of Board meeting"
            },
            {
                "key": "companyHistory.154.date",
                "value": "2005-12-01T00:00:00Z"
            },
            {
                "key": "companyHistory.154.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.155.date",
                "value": "2005-12-01T00:00:00Z"
            },
            {
                "key": "companyHistory.155.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.156.date",
                "value": "2005-12-01T00:00:00Z"
            },
            {
                "key": "companyHistory.156.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.157.date",
                "value": "2003-07-11T00:00:00Z"
            },
            {
                "key": "companyHistory.157.description",
                "value": "Appointment\/resignation of company officers"
            },
            {
                "key": "companyHistory.158.date",
                "value": "2003-07-11T00:00:00Z"
            },
            {
                "key": "companyHistory.158.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.159.date",
                "value": "2003-07-11T00:00:00Z"
            },
            {
                "key": "companyHistory.159.description",
                "value": "Minutes of Board meeting"
            },
            {
                "key": "companyHistory.160.date",
                "value": "2003-07-11T00:00:00Z"
            },
            {
                "key": "companyHistory.160.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.161.date",
                "value": "2003-07-11T00:00:00Z"
            },
            {
                "key": "companyHistory.161.description",
                "value": "New auditor"
            },
            {
                "key": "companyHistory.162.date",
                "value": "2003-07-11T00:00:00Z"
            },
            {
                "key": "companyHistory.162.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.163.date",
                "value": "2003-07-11T00:00:00Z"
            },
            {
                "key": "companyHistory.163.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.164.date",
                "value": "2001-09-11T00:00:00Z"
            },
            {
                "key": "companyHistory.164.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.165.date",
                "value": "2001-09-11T00:00:00Z"
            },
            {
                "key": "companyHistory.165.description",
                "value": "Capital increase"
            },
            {
                "key": "companyHistory.166.date",
                "value": "2001-09-11T00:00:00Z"
            },
            {
                "key": "companyHistory.166.description",
                "value": "Conversion of equity to euro"
            },
            {
                "key": "companyHistory.167.date",
                "value": "2001-09-11T00:00:00Z"
            },
            {
                "key": "companyHistory.167.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.168.date",
                "value": "2001-09-11T00:00:00Z"
            },
            {
                "key": "companyHistory.168.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.169.date",
                "value": "2001-09-11T00:00:00Z"
            },
            {
                "key": "companyHistory.169.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.170.date",
                "value": "1999-02-04T00:00:00Z"
            },
            {
                "key": "companyHistory.170.description",
                "value": "Registered office transferred inside jurisdiction of the Commercial Court"
            },
            {
                "key": "companyHistory.171.date",
                "value": "1999-02-04T00:00:00Z"
            },
            {
                "key": "companyHistory.171.description",
                "value": "Registration after transfer"
            },
            {
                "key": "companyHistory.172.date",
                "value": "1999-02-04T00:00:00Z"
            },
            {
                "key": "companyHistory.172.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.173.date",
                "value": "1999-02-04T00:00:00Z"
            },
            {
                "key": "companyHistory.173.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.174.date",
                "value": "1999-02-04T00:00:00Z"
            },
            {
                "key": "companyHistory.174.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.175.date",
                "value": "1999-02-04T00:00:00Z"
            },
            {
                "key": "companyHistory.175.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.176.date",
                "value": "1997-03-26T00:00:00Z"
            },
            {
                "key": "companyHistory.176.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.177.date",
                "value": "1997-03-26T00:00:00Z"
            },
            {
                "key": "companyHistory.177.description",
                "value": "Minutes of Board meeting"
            },
            {
                "key": "companyHistory.178.date",
                "value": "1997-03-26T00:00:00Z"
            },
            {
                "key": "companyHistory.178.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.179.date",
                "value": "1997-03-26T00:00:00Z"
            },
            {
                "key": "companyHistory.179.description",
                "value": "Appointment\/resignation of company officers"
            },
            {
                "key": "companyHistory.180.date",
                "value": "1997-03-26T00:00:00Z"
            },
            {
                "key": "companyHistory.180.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.181.date",
                "value": "1997-03-17T00:00:00Z"
            },
            {
                "key": "companyHistory.181.description",
                "value": "Private document"
            },
            {
                "key": "companyHistory.182.date",
                "value": "1997-03-17T00:00:00Z"
            },
            {
                "key": "companyHistory.182.description",
                "value": "Changes to the Board of Directors"
            },
            {
                "key": "companyHistory.183.date",
                "value": "1997-03-17T00:00:00Z"
            },
            {
                "key": "companyHistory.183.description",
                "value": "Appointment\/resignation of company officers"
            },
            {
                "key": "companyHistory.184.date",
                "value": "1997-03-17T00:00:00Z"
            },
            {
                "key": "companyHistory.184.description",
                "value": "Amendment"
            },
            {
                "key": "companyHistory.185.date",
                "value": "1997-03-17T00:00:00Z"
            },
            {
                "key": "companyHistory.185.description",
                "value": "Minutes of Board meeting"
            },
            {
                "key": "companyHistory.186.date",
                "value": "1993-12-03T00:00:00Z"
            },
            {
                "key": "companyHistory.186.description",
                "value": "Registration after transfer"
            },
            {
                "key": "companyHistory.187.date",
                "value": "1993-12-03T00:00:00Z"
            },
            {
                "key": "companyHistory.187.description",
                "value": "Minutes of general meeting of shareholders"
            },
            {
                "key": "companyHistory.188.date",
                "value": "1993-12-03T00:00:00Z"
            },
            {
                "key": "companyHistory.188.description",
                "value": "Minutes of Board meeting"
            },
            {
                "key": "companyHistory.189.date",
                "value": "1993-12-03T00:00:00Z"
            },
            {
                "key": "companyHistory.189.description",
                "value": "Declaration of conformity"
            },
            {
                "key": "companyHistory.190.date",
                "value": "1993-12-03T00:00:00Z"
            },
            {
                "key": "companyHistory.190.description",
                "value": "Articles of association"
            },
            {
                "key": "companyHistory.191.date",
                "value": "1993-12-03T00:00:00Z"
            },
            {
                "key": "companyHistory.191.description",
                "value": "Updated articles of association"
            },
            {
                "key": "companyHistory.192.date",
                "value": "1993-11-10T00:00:00Z"
            },
            {
                "key": "companyHistory.192.description",
                "value": "Registered office transferred outside jurisdiction of the Commercial Court"
            },
            {
                "key": "companyHistory.193.date",
                "value": "1993-11-10T00:00:00Z"
            },
            {
                "key": "companyHistory.193.description",
                "value": "Minutes of Board meeting"
            },
            {
                "key": "establishmentHistory.0.date",
                "value": "2017-05-28T00:00:00Z"
            },
            {
                "key": "establishmentHistory.0.description",
                "value": "Update of phone numbers"
            },
            {
                "key": "establishmentHistory.1.date",
                "value": "2017-03-26T00:00:00Z"
            },
            {
                "key": "establishmentHistory.1.description",
                "value": "Update of phone numbers"
            },
            {
                "key": "establishmentHistory.2.date",
                "value": "2014-08-13T00:00:00Z"
            },
            {
                "key": "establishmentHistory.2.description",
                "value": "Update of phone numbers"
            },
            {
                "key": "establishmentHistory.3.date",
                "value": "2013-01-02T00:00:00Z"
            },
            {
                "key": "establishmentHistory.3.description",
                "value": "Formation of Head office (after transfer)"
            },
            {
                "key": "gazettePublications.0.publicationDate",
                "value": "2024-10-31T00:00:00Z"
            },
            {
                "key": "gazettePublications.0.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.0.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.0.details",
                "value": "<center><b>74 - HAUTE SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>2605 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 par Actions Simplifi\u00e9e. <i>Administration : <\/i>St\u00e9 par actions simplifi\u00e9e Cosmelux Holdco devient pr\u00e9sident. St\u00e9 par actions simplifi\u00e9e Cosm\u00e9Lux International n'est plus pr\u00e9sident. <br><br><i>Commentaires : <\/i>Modification de l'administration."
            },
            {
                "key": "gazettePublications.0.fullContent",
                "value": "74 - HAUTE SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n2605 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 par Actions Simplifi\u00e9e. Administration : St\u00e9 par actions simplifi\u00e9e Cosmelux Holdco devient pr\u00e9sident. St\u00e9 par actions simplifi\u00e9e Cosm\u00e9Lux International n'est plus pr\u00e9sident. Commentaires : Modification de l'administration."
            },
            {
                "key": "gazettePublications.0.publicationID",
                "value": "074020000077353260520240212NEW"
            },
            {
                "key": "gazettePublications.1.publicationDate",
                "value": "2024-10-24T00:00:00Z"
            },
            {
                "key": "gazettePublications.1.eventDate",
                "value": "2024-09-26T00:00:00Z"
            },
            {
                "key": "gazettePublications.1.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.1.description",
                "value": "Modifications diverses"
            },
            {
                "key": "gazettePublications.1.details",
                "value": "<center><b>Non communiqu\u00e9<\/b><\/center> <br \/><i>Date de d\u00e9cision :<\/i> 26\/09\/2024 <br \/><i>Entreprise :<\/i> 712023043 - LABLABO,  0269 RUE GEORGES CHARPAK,  74100 JUVIGNY <br \/><i>Description :<\/i> Modification des dirigeants"
            },
            {
                "key": "gazettePublications.1.fullContent",
                "value": "Publi\u00e9e Ie 24 octobre 2024 dans Le Faucigny.fr (en Iigne) (D\u00e9pt. 74) LABLABO SASU Au capital de 43.200.00 \u20ac Si\u00e8ge social : 269 rue Georges Charpak 74100 Juvigny  712 023 043 R.C.S. Thonon-les-bains Suivant extrait des d\u00e9cisions de l'associ\u00e9 unique en date du 26\/09\/2024, il a \u00e9t\u00e9 d\u00e9cid\u00e9 de nommer en qualit\u00e9 de Pr\u00e9sident, la SAS \"COSMELUX  HOLDCO\", sise 353 rue de la fontaine 01100 Martignat, 930 747 506 RCS Bourg-en-Bresse, en lieu et place de la soci\u00e9t\u00e9 \"Cosmelux InternationaP  d\u00e9missionnaire. o Cette annonce sera visible jusqu'au 25 janvier 2025. o Xum\u00e9ro d'annonce : X2024J11479"
            },
            {
                "key": "gazettePublications.1.publicationID",
                "value": "O\/5003451480\/712023043\/01_2150\/24-OCT-2024"
            },
            {
                "key": "gazettePublications.2.publicationDate",
                "value": "2021-05-20T00:00:00Z"
            },
            {
                "key": "gazettePublications.2.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.2.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.2.details",
                "value": "<center><b>74 - HAUTE SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>3168 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 par Actions Simplifi\u00e9e. <i>Administration : <\/i>St\u00e9 par actions simplifi\u00e9e RSM Rh\u00f4ne-Alpes n'est plus commissaire aux comptes titulaire. <i>Activit\u00e9 : <\/i> . <br><i>Commentaires : <\/i>Modification de l'administration."
            },
            {
                "key": "gazettePublications.2.fullContent",
                "value": "74 - HAUTE SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n3168 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 par Actions Simplifi\u00e9e. Administration : St\u00e9 par actions simplifi\u00e9e RSM Rh\u00f4ne-Alpes n'est plus commissaire aux comptes titulaire. Activit\u00e9 :  . Commentaires : Modification de l'administration."
            },
            {
                "key": "gazettePublications.2.publicationID",
                "value": "074020000023396316820210098NEW"
            },
            {
                "key": "gazettePublications.3.publicationDate",
                "value": "2019-11-26T00:00:00Z"
            },
            {
                "key": "gazettePublications.3.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.3.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.3.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>2752 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 par actions simplifi\u00e9e. <i>Administration : <\/i>Pr\u00e9sident : Cosm\u00e9Lux International (SAS)\u00a0; Commissaire aux comptes titulaire : RSM CCI CONSEILS (SAS) repr\u00e9sent\u00e9 par MONNERET Pierre\u00a0; Commissaire aux comptes titulaire : ERNST & YOUNG et Autres (SAS). <i>Activit\u00e9 : <\/i> . <br><i>Commentaires : <\/i>Modification survenue sur la forme juridique, l'administration."
            },
            {
                "key": "gazettePublications.3.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n2752 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 par actions simplifi\u00e9e. Administration : Pr\u00e9sident : Cosm\u00e9Lux International (SAS)\u00a0; Commissaire aux comptes titulaire : RSM CCI CONSEILS (SAS) repr\u00e9sent\u00e9 par MONNERET Pierre\u00a0; Commissaire aux comptes titulaire : ERNST & YOUNG et Autres (SAS). Activit\u00e9 :  . Commentaires : Modification survenue sur la forme juridique, l'administration."
            },
            {
                "key": "gazettePublications.3.publicationID",
                "value": "000007402119218275220190227NEW"
            },
            {
                "key": "gazettePublications.4.publicationDate",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "gazettePublications.4.eventDate",
                "value": "2019-09-24T00:00:00Z"
            },
            {
                "key": "gazettePublications.4.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.4.description",
                "value": "Change of legal form"
            },
            {
                "key": "gazettePublications.4.details",
                "value": "<center><b>Le Faucigny<\/b><\/center> <br \/><i>Date de d\u00e9cision :<\/i> 24\/09\/2019 <br \/><i>Forme juridique :<\/i> SAS <br \/>"
            },
            {
                "key": "gazettePublications.4.fullContent",
                "value": "F2019I01275 LABLABO Soci\u00e9t\u00e9 Anonyme \u00e0 Conseil  d'Administration  Au capital de 43.200 euros  Si\u00e8ge Social : 269 rue Georges  Charpak 74100 Juvigny  712 023 043  RCS Thonon Les Bains Suivant PV de l'Actionnaire unique en date  du 24-09-2019, la soci\u00e9t\u00e9 ERNST &YOUNG  ET AUTRES, sise 1-2 place des Saisons Paris  la D\u00e9fense 1 - 92400 Courbevoie a \u00e9t\u00e9 nom\u00ad m\u00e9e co-commissaire aux comptes titulaire, \u00e0  compter de ce jour. Aux termes du m\u00eame acte, il a \u00e9t\u00e9 d\u00e9cid\u00e9  de la transformation de la Soci\u00e9t\u00e9 en soci\u00e9t\u00e9  par actions simplifi\u00e9e \u00e0 compter du m\u00eame jour,  sans cr\u00e9ation d'un \u00eatre moral nouveau et a  adopt\u00e9 le texte des statuts qui r\u00e9giront d\u00e9sor\u00ad mais la Soci\u00e9t\u00e9. La d\u00e9nomination de la So\u00ad ci\u00e9t\u00e9, son objet, son si\u00e8ge, sa dur\u00e9e et son  capital demeurent inchang\u00e9s. Admission aux assembl\u00e9es et droit de  vote :Tout associ\u00e9 peut participer aux assem\u00ad bl\u00e9es . Le droit de vote attach\u00e9 aux actions est  proportionnel \u00e0 la quotit\u00e9 du capital qu'elles  repr\u00e9sentent, et chaque titre donne droit \u00e0 une  voix au moins.Toute transmission d'actions est  libre. La transformation a mis fin aux fonctions  des administrateurs et \u00e0 tous organes de di\u00ad rection ; sous sa nouvelle forme la soci\u00e9t\u00e9  nomme Pr\u00e9sident la soci\u00e9t\u00e9 Cosm\u00e9lux Inter\u00ad national, SAS au capital de 42.478 814 euros,  sise 353 rue de la Fontaine 01100 Martignat,  immatricul\u00e9e au RCS de Bourg-en-Bresse n\u00b0  830 581 526. Les co-commissaires aux comptes titu\u00ad laires, la soci\u00e9t\u00e9 RSM Rh\u00f4ne-Alpes (ancien\u00ad nement d\u00e9nomm\u00e9e RSM CCI CONSEILS) et  la soci\u00e9t\u00e9 ERNST&YOUNG ET AUTRES, sont  maintenus dans leurs fonctions. Il est pris acte  de la d\u00e9mission de Monsieur PENNEQUIN  Jean-Marc, commissaire aux comptes sup\u00ad pl\u00e9ant, \u00e0 compter du 24\/09\/2019, non rem\u00ad plac\u00e9. Le d\u00e9p\u00f4t des actes sera effectu\u00e9 aupr\u00e8s du  Greffe du Tribunal de Commerce de Thonon  les Bains."
            },
            {
                "key": "gazettePublications.4.publicationID",
                "value": "O\/5526257\/712023043\/4128\/21-NOV-2019"
            },
            {
                "key": "gazettePublications.5.publicationDate",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "gazettePublications.5.eventDate",
                "value": "2019-09-24T00:00:00Z"
            },
            {
                "key": "gazettePublications.5.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.5.description",
                "value": "Modifications diverses"
            },
            {
                "key": "gazettePublications.5.details",
                "value": "<center><b>Le Faucigny<\/b><\/center> <br \/><i>Date de d\u00e9cision :<\/i> 24\/09\/2019 <br \/><i>Entreprise :<\/i> 712023043 - LABLABO,  269 RUE GEORGES CHARPAK,  74100 JUVIGNY <br \/><i>Description :<\/i> Modification des dirigeants"
            },
            {
                "key": "gazettePublications.5.fullContent",
                "value": "F2019I01275 LABLABO Soci\u00e9t\u00e9 Anonyme \u00e0 Conseil  d'Administration  Au capital de 43.200 euros  Si\u00e8ge Social : 269 rue Georges  Charpak 74100 Juvigny  712 023 043  RCS Thonon Les Bains Suivant PV de l'Actionnaire unique en date  du 24-09-2019, la soci\u00e9t\u00e9 ERNST &YOUNG  ET AUTRES, sise 1-2 place des Saisons Paris  la D\u00e9fense 1 - 92400 Courbevoie a \u00e9t\u00e9 nom\u00ad m\u00e9e co-commissaire aux comptes titulaire, \u00e0  compter de ce jour. Aux termes du m\u00eame acte, il a \u00e9t\u00e9 d\u00e9cid\u00e9  de la transformation de la Soci\u00e9t\u00e9 en soci\u00e9t\u00e9  par actions simplifi\u00e9e \u00e0 compter du m\u00eame jour,  sans cr\u00e9ation d'un \u00eatre moral nouveau et a  adopt\u00e9 le texte des statuts qui r\u00e9giront d\u00e9sor\u00ad mais la Soci\u00e9t\u00e9. La d\u00e9nomination de la So\u00ad ci\u00e9t\u00e9, son objet, son si\u00e8ge, sa dur\u00e9e et son  capital demeurent inchang\u00e9s. Admission aux assembl\u00e9es et droit de  vote :Tout associ\u00e9 peut participer aux assem\u00ad bl\u00e9es . Le droit de vote attach\u00e9 aux actions est  proportionnel \u00e0 la quotit\u00e9 du capital qu'elles  repr\u00e9sentent, et chaque titre donne droit \u00e0 une  voix au moins.Toute transmission d'actions est  libre. La transformation a mis fin aux fonctions  des administrateurs et \u00e0 tous organes de di\u00ad rection ; sous sa nouvelle forme la soci\u00e9t\u00e9  nomme Pr\u00e9sident la soci\u00e9t\u00e9 Cosm\u00e9lux Inter\u00ad national, SAS au capital de 42.478 814 euros,  sise 353 rue de la Fontaine 01100 Martignat,  immatricul\u00e9e au RCS de Bourg-en-Bresse n\u00b0  830 581 526. Les co-commissaires aux comptes titu\u00ad laires, la soci\u00e9t\u00e9 RSM Rh\u00f4ne-Alpes (ancien\u00ad nement d\u00e9nomm\u00e9e RSM CCI CONSEILS) et  la soci\u00e9t\u00e9 ERNST&YOUNG ET AUTRES, sont  maintenus dans leurs fonctions. Il est pris acte  de la d\u00e9mission de Monsieur PENNEQUIN  Jean-Marc, commissaire aux comptes sup\u00ad pl\u00e9ant, \u00e0 compter du 24\/09\/2019, non rem\u00ad plac\u00e9. Le d\u00e9p\u00f4t des actes sera effectu\u00e9 aupr\u00e8s du  Greffe du Tribunal de Commerce de Thonon  les Bains."
            },
            {
                "key": "gazettePublications.5.publicationID",
                "value": "O\/5526257\/712023043\/01_2150\/21-NOV-2019"
            },
            {
                "key": "gazettePublications.6.publicationDate",
                "value": "2019-11-21T00:00:00Z"
            },
            {
                "key": "gazettePublications.6.eventDate",
                "value": "2019-09-24T00:00:00Z"
            },
            {
                "key": "gazettePublications.6.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.6.description",
                "value": "Modifications diverses"
            },
            {
                "key": "gazettePublications.6.details",
                "value": "<center><b>Le Faucigny<\/b><\/center> <br \/><i>Date de d\u00e9cision :<\/i> 24\/09\/2019 <br \/><i>Entreprise :<\/i> 712023043 - LABLABO,  269 RUE GEORGES CHARPAK,  74100 JUVIGNY <br \/><i>Description :<\/i> Nomination d'un administrateur"
            },
            {
                "key": "gazettePublications.6.fullContent",
                "value": "F2019I01275 LABLABO Soci\u00e9t\u00e9 Anonyme \u00e0 Conseil  d'Administration  Au capital de 43.200 euros  Si\u00e8ge Social : 269 rue Georges  Charpak 74100 Juvigny  712 023 043  RCS Thonon Les Bains Suivant PV de l'Actionnaire unique en date  du 24-09-2019, la soci\u00e9t\u00e9 ERNST &YOUNG  ET AUTRES, sise 1-2 place des Saisons Paris  la D\u00e9fense 1 - 92400 Courbevoie a \u00e9t\u00e9 nom\u00ad m\u00e9e co-commissaire aux comptes titulaire, \u00e0  compter de ce jour. Aux termes du m\u00eame acte, il a \u00e9t\u00e9 d\u00e9cid\u00e9  de la transformation de la Soci\u00e9t\u00e9 en soci\u00e9t\u00e9  par actions simplifi\u00e9e \u00e0 compter du m\u00eame jour,  sans cr\u00e9ation d'un \u00eatre moral nouveau et a  adopt\u00e9 le texte des statuts qui r\u00e9giront d\u00e9sor\u00ad mais la Soci\u00e9t\u00e9. La d\u00e9nomination de la So\u00ad ci\u00e9t\u00e9, son objet, son si\u00e8ge, sa dur\u00e9e et son  capital demeurent inchang\u00e9s. Admission aux assembl\u00e9es et droit de  vote :Tout associ\u00e9 peut participer aux assem\u00ad bl\u00e9es . Le droit de vote attach\u00e9 aux actions est  proportionnel \u00e0 la quotit\u00e9 du capital qu'elles  repr\u00e9sentent, et chaque titre donne droit \u00e0 une  voix au moins.Toute transmission d'actions est  libre. La transformation a mis fin aux fonctions  des administrateurs et \u00e0 tous organes de di\u00ad rection ; sous sa nouvelle forme la soci\u00e9t\u00e9  nomme Pr\u00e9sident la soci\u00e9t\u00e9 Cosm\u00e9lux Inter\u00ad national, SAS au capital de 42.478 814 euros,  sise 353 rue de la Fontaine 01100 Martignat,  immatricul\u00e9e au RCS de Bourg-en-Bresse n\u00b0  830 581 526. Les co-commissaires aux comptes titu\u00ad laires, la soci\u00e9t\u00e9 RSM Rh\u00f4ne-Alpes (ancien\u00ad nement d\u00e9nomm\u00e9e RSM CCI CONSEILS) et  la soci\u00e9t\u00e9 ERNST&YOUNG ET AUTRES, sont  maintenus dans leurs fonctions. Il est pris acte  de la d\u00e9mission de Monsieur PENNEQUIN  Jean-Marc, commissaire aux comptes sup\u00ad pl\u00e9ant, \u00e0 compter du 24\/09\/2019, non rem\u00ad plac\u00e9. Le d\u00e9p\u00f4t des actes sera effectu\u00e9 aupr\u00e8s du  Greffe du Tribunal de Commerce de Thonon  les Bains."
            },
            {
                "key": "gazettePublications.6.publicationID",
                "value": "O\/5526257\/712023043\/01_2151\/21-NOV-2019"
            },
            {
                "key": "gazettePublications.7.publicationDate",
                "value": "2019-11-13T00:00:00Z"
            },
            {
                "key": "gazettePublications.7.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.7.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.7.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>2077 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Administration : <\/i>Pr\u00e9sident du conseil d'administration, Directeur g\u00e9n\u00e9ral : PINARD Thomas, Sylvain\u00a0; Directeur g\u00e9n\u00e9ral d\u00e9l\u00e9gu\u00e9 : TABERLET J\u00e9r\u00e9mie\u00a0; Administrateur : RICHARD Thibaut\u00a0; Administrateur : SOUDRY Dan\u00a0; Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre\u00a0; Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. <i>Activit\u00e9 : <\/i> . <br><i>Commentaires : <\/i>Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.7.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n2077 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Administration : Pr\u00e9sident du conseil d'administration, Directeur g\u00e9n\u00e9ral : PINARD Thomas, Sylvain\u00a0; Directeur g\u00e9n\u00e9ral d\u00e9l\u00e9gu\u00e9 : TABERLET J\u00e9r\u00e9mie\u00a0; Administrateur : RICHARD Thibaut\u00a0; Administrateur : SOUDRY Dan\u00a0; Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre\u00a0; Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. Activit\u00e9 :  . Commentaires : Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.7.publicationID",
                "value": "000007402118659207720190218NEW"
            },
            {
                "key": "gazettePublications.8.publicationDate",
                "value": "2019-11-13T00:00:00Z"
            },
            {
                "key": "gazettePublications.8.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.8.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.8.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>2078 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Administration : <\/i>Pr\u00e9sident du conseil d'administration, Directeur g\u00e9n\u00e9ral : PINARD Thomas, Sylvain\u00a0; Administrateur : RICHARD Thibaut\u00a0; Administrateur : SOUDRY Dan\u00a0; Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre\u00a0; Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. <i>Activit\u00e9 : <\/i> . <br><i>Commentaires : <\/i>Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.8.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n2078 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Administration : Pr\u00e9sident du conseil d'administration, Directeur g\u00e9n\u00e9ral : PINARD Thomas, Sylvain\u00a0; Administrateur : RICHARD Thibaut\u00a0; Administrateur : SOUDRY Dan\u00a0; Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre\u00a0; Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. Activit\u00e9 :  . Commentaires : Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.8.publicationID",
                "value": "000007402118734207820190218NEW"
            },
            {
                "key": "gazettePublications.9.publicationDate",
                "value": "2019-11-01T00:00:00Z"
            },
            {
                "key": "gazettePublications.9.eventDate",
                "value": "2019-08-01T00:00:00Z"
            },
            {
                "key": "gazettePublications.9.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.9.description",
                "value": "Modifications diverses"
            },
            {
                "key": "gazettePublications.9.details",
                "value": "<center><b>L'Eco des Pays de Savoie<\/b><\/center> <br \/><i>Date de d\u00e9cision :<\/i> 01\/08\/2019 <br \/><i>Entreprise :<\/i> 712023043 - LABLABO,  269 RUE GEORGES CHARPAK,  74100 JUVIGNY <br \/><i>Description :<\/i> Modification des dirigeants"
            },
            {
                "key": "gazettePublications.9.fullContent",
                "value": "MODIFICATIONS LABLABO SA au capital de 43.200 euros  Si\u00e8ge social : 74100 JUVIGNY  269 rue Georges Charpak  712 023 043 R.C.S THONON-LES-BAINS (1) Aux termes des d\u00e9cisions du  conseil d\u2019administration du 1er ao\u00fbt  2019 : (i) Thomas PINARD, demeurant  7 rampe de Fesigny 74290 VEYRIER  DU LAC, a \u00e9t\u00e9 nomm\u00e9 en qualit\u00e9 de  directeur g\u00e9n\u00e9ral et pr\u00e9sident du conseil  d\u2019administration, en remplacement de  Jean-Philippe TABERLET ; (ii) Thibaut  RICHARD, demeurant 93 rue Lamarck  75018 PARIS, et Dan SOUDRY, demeu\u00ad rant 4 boulevard de Courcelles 75017  PARIS, ont \u00e9t\u00e9 nomm\u00e9s membres  du conseil d\u2019administration, en rem\u00ad placement de J\u00e9r\u00e9mie TABERLET et  :ran\u00e7oise TABERLET ; (iii) Il a \u00e9t\u00e9 pris  acte des d\u00e9missions de Marie ARNAL  et Benjamin TABERLET de leurs fonc\u00ad tions de membres du conseil d\u2019admi\u00ad nistration ; (2) Aux termes des d\u00e9cisions  de l\u2019associ\u00e9 unique du 30 septembre  2019, il a \u00e9t\u00e9 pris acte de la d\u00e9mission  de J\u00e9r\u00e9mie TABERLET de ses fonctions  de directeur g\u00e9n\u00e9ral d\u00e9l\u00e9gu\u00e9. ECO 74 8008 01\/11\/19"
            },
            {
                "key": "gazettePublications.9.publicationID",
                "value": "O\/5447355\/712023043\/01_2150\/01-NOV-2019"
            },
            {
                "key": "gazettePublications.10.publicationDate",
                "value": "2019-11-01T00:00:00Z"
            },
            {
                "key": "gazettePublications.10.eventDate",
                "value": "2019-08-01T00:00:00Z"
            },
            {
                "key": "gazettePublications.10.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.10.description",
                "value": "Modifications diverses"
            },
            {
                "key": "gazettePublications.10.details",
                "value": "<center><b>L'Eco des Pays de Savoie<\/b><\/center> <br \/><i>Date de d\u00e9cision :<\/i> 01\/08\/2019 <br \/><i>Entreprise :<\/i> 712023043 - LABLABO,  269 RUE GEORGES CHARPAK,  74100 JUVIGNY <br \/><i>Description :<\/i> Nomination d'un administrateur"
            },
            {
                "key": "gazettePublications.10.fullContent",
                "value": "MODIFICATIONS LABLABO SA au capital de 43.200 euros  Si\u00e8ge social : 74100 JUVIGNY  269 rue Georges Charpak  712 023 043 R.C.S THONON-LES-BAINS (1) Aux termes des d\u00e9cisions du  conseil d\u2019administration du 1er ao\u00fbt  2019 : (i) Thomas PINARD, demeurant  7 rampe de Fesigny 74290 VEYRIER  DU LAC, a \u00e9t\u00e9 nomm\u00e9 en qualit\u00e9 de  directeur g\u00e9n\u00e9ral et pr\u00e9sident du conseil  d\u2019administration, en remplacement de  Jean-Philippe TABERLET ; (ii) Thibaut  RICHARD, demeurant 93 rue Lamarck  75018 PARIS, et Dan SOUDRY, demeu\u00ad rant 4 boulevard de Courcelles 75017  PARIS, ont \u00e9t\u00e9 nomm\u00e9s membres  du conseil d\u2019administration, en rem\u00ad placement de J\u00e9r\u00e9mie TABERLET et  :ran\u00e7oise TABERLET ; (iii) Il a \u00e9t\u00e9 pris  acte des d\u00e9missions de Marie ARNAL  et Benjamin TABERLET de leurs fonc\u00ad tions de membres du conseil d\u2019admi\u00ad nistration ; (2) Aux termes des d\u00e9cisions  de l\u2019associ\u00e9 unique du 30 septembre  2019, il a \u00e9t\u00e9 pris acte de la d\u00e9mission  de J\u00e9r\u00e9mie TABERLET de ses fonctions  de directeur g\u00e9n\u00e9ral d\u00e9l\u00e9gu\u00e9. ECO 74 8008 01\/11\/19"
            },
            {
                "key": "gazettePublications.10.publicationID",
                "value": "O\/5447355\/712023043\/01_2151\/01-NOV-2019"
            },
            {
                "key": "gazettePublications.11.publicationDate",
                "value": "2019-06-20T00:00:00Z"
            },
            {
                "key": "gazettePublications.11.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.11.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.11.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>11438 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>269 rue Georges Charpak   74100 Juvigny. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2018."
            },
            {
                "key": "gazettePublications.11.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n11438 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 269 rue Georges Charpak   74100 Juvigny. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2018."
            },
            {
                "key": "gazettePublications.11.publicationID",
                "value": "7402113247000001143820190117NEW"
            },
            {
                "key": "gazettePublications.12.publicationDate",
                "value": "2018-07-25T00:00:00Z"
            },
            {
                "key": "gazettePublications.12.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.12.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.12.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>7121 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>269 rue Georges Charpak   74100 Juvigny. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2017."
            },
            {
                "key": "gazettePublications.12.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n7121 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 269 rue Georges Charpak   74100 Juvigny. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2017."
            },
            {
                "key": "gazettePublications.12.publicationID",
                "value": "740210162400000712120180134NEW"
            },
            {
                "key": "gazettePublications.13.publicationDate",
                "value": "2018-02-02T00:00:00Z"
            },
            {
                "key": "gazettePublications.13.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.13.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.13.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>1094 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Administration : <\/i>Directeur g\u00e9n\u00e9ral, Pr\u00e9sident : TABERLET Jean-Philippe, Marie\u00a0; Administrateur : TABERLET Fran\u00e7oise, Andr\u00e9e n\u00e9(e) JEAN\u00a0; Directeur g\u00e9n\u00e9ral, Administrateur : TABERLET J\u00e9r\u00e9mie\u00a0; Administrateur : ARNAL Marie, C\u00e9line, Eva n\u00e9(e) TABERLET\u00a0; Administrateur : TABERLET Benjamin, Joseph\u00a0; Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre\u00a0; Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. <i>Activit\u00e9 : <\/i> . <br><i>Commentaires : <\/i>Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.13.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n1094 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Administration : Directeur g\u00e9n\u00e9ral, Pr\u00e9sident : TABERLET Jean-Philippe, Marie\u00a0; Administrateur : TABERLET Fran\u00e7oise, Andr\u00e9e n\u00e9(e) JEAN\u00a0; Directeur g\u00e9n\u00e9ral, Administrateur : TABERLET J\u00e9r\u00e9mie\u00a0; Administrateur : ARNAL Marie, C\u00e9line, Eva n\u00e9(e) TABERLET\u00a0; Administrateur : TABERLET Benjamin, Joseph\u00a0; Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre\u00a0; Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. Activit\u00e9 :  . Commentaires : Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.13.publicationID",
                "value": "000000740296019109420180023NEW"
            },
            {
                "key": "gazettePublications.14.publicationDate",
                "value": "2018-01-18T00:00:00Z"
            },
            {
                "key": "gazettePublications.14.eventDate",
                "value": "2017-11-12T00:00:00Z"
            },
            {
                "key": "gazettePublications.14.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.14.description",
                "value": "Appointment of the social representative"
            },
            {
                "key": "gazettePublications.14.details",
                "value": "<center><b>L Eco des Pays de Savoie<\/b><\/center><br \/><i>Date de d\u00e9cision : <\/i>12\/11\/2017<br \/><i> Nomin\u00e9 : <\/i>Monsieur J\u00e9r\u00e9mie TABERLET, 74250 VILLE EN SALLAZ<br\/><i> En la fonction de : <\/i>Directeur g\u00e9n\u00e9ral<br\/>"
            },
            {
                "key": "gazettePublications.14.publicationID",
                "value": "K\/12227907\/712023043\/4108\/18-01-2018"
            },
            {
                "key": "gazettePublications.15.publicationDate",
                "value": "2017-08-29T00:00:00Z"
            },
            {
                "key": "gazettePublications.15.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.15.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.15.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>3176 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>269 rue Georges Charpak   74100 Juvigny. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2016."
            },
            {
                "key": "gazettePublications.15.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n3176 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 269 rue Georges Charpak   74100 Juvigny. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2016."
            },
            {
                "key": "gazettePublications.15.publicationID",
                "value": "740290963000000317620170087NEW"
            },
            {
                "key": "gazettePublications.16.publicationDate",
                "value": "2017-03-24T00:00:00Z"
            },
            {
                "key": "gazettePublications.16.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.16.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.16.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>8086 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>269 rue Georges Charpak   74100 Juvigny. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2015."
            },
            {
                "key": "gazettePublications.16.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n8086 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 269 rue Georges Charpak   74100 Juvigny. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2015."
            },
            {
                "key": "gazettePublications.16.publicationID",
                "value": "740284632000000808620170024NEW"
            },
            {
                "key": "gazettePublications.17.publicationDate",
                "value": "2016-01-13T00:00:00Z"
            },
            {
                "key": "gazettePublications.17.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.17.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.17.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>2417 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Administration : <\/i>Directeur g\u00e9n\u00e9ral, Pr\u00e9sident : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Fran\u00e7oise, Andr\u00e9e n\u00e9(e) JEAN Administrateur : TABERLET J\u00e9r\u00e9mie Administrateur : ARNAL Marie, C\u00e9line, Eva n\u00e9(e) TABERLET Administrateur : TABERLET Benjamin, Joseph Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. <i>Activit\u00e9 : <\/i> . <br><i>Commentaires : <\/i>Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.17.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n2417 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Administration : Directeur g\u00e9n\u00e9ral, Pr\u00e9sident : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Fran\u00e7oise, Andr\u00e9e n\u00e9(e) JEAN Administrateur : TABERLET J\u00e9r\u00e9mie Administrateur : ARNAL Marie, C\u00e9line, Eva n\u00e9(e) TABERLET Administrateur : TABERLET Benjamin, Joseph Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. Activit\u00e9 :  . Commentaires : Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.17.publicationID",
                "value": "BXB160060021438241720160008NEW"
            },
            {
                "key": "gazettePublications.18.publicationDate",
                "value": "2015-11-27T00:00:00Z"
            },
            {
                "key": "gazettePublications.18.eventDate",
                "value": "2015-11-06T00:00:00Z"
            },
            {
                "key": "gazettePublications.18.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.18.description",
                "value": "Appointment of the social representative"
            },
            {
                "key": "gazettePublications.18.details",
                "value": "<center><b>Eco des Pays de Savoie (L )<\/b><\/center><br \/><i>Date de d\u00e9cision : <\/i>06\/11\/2015<br \/><i>Soci\u00e9t\u00e9 faisant l'objet d'une nomination : <\/i>712023043 - LABLABO, 269 RUE GEORGES CHARPAK, 74100 JUVIGNY <br\/><i> Nomin\u00e9 : <\/i>Madame Marie ARNAL, 12230 SAUCLIERES<br\/><i> En la fonction de : <\/i>Administrateur<br\/><i> Nomin\u00e9 : <\/i>Monsieur Benjamin TABERLET, 74420 ST ANDRE DE BOEGE<br\/><i> En la fonction de : <\/i>Administrateur<br\/>"
            },
            {
                "key": "gazettePublications.18.publicationID",
                "value": "K\/6000954\/712023043\/4108\/27-11-2015"
            },
            {
                "key": "gazettePublications.19.publicationDate",
                "value": "2015-10-03T00:00:00Z"
            },
            {
                "key": "gazettePublications.19.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.19.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.19.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>5054 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>269 rue Georges Charpak   74100 Juvigny. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2014."
            },
            {
                "key": "gazettePublications.19.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n5054 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 269 rue Georges Charpak   74100 Juvigny. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2014."
            },
            {
                "key": "gazettePublications.19.publicationID",
                "value": "740270151000000505420150101NEW"
            },
            {
                "key": "gazettePublications.20.publicationDate",
                "value": "2014-12-13T00:00:00Z"
            },
            {
                "key": "gazettePublications.20.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.20.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.20.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>11645 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>269 rue Georges Charpak   74100 Juvigny. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2013."
            },
            {
                "key": "gazettePublications.20.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n11645 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 269 rue Georges Charpak   74100 Juvigny. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2013."
            },
            {
                "key": "gazettePublications.20.publicationID",
                "value": "7402609630000001164520140094NEW"
            },
            {
                "key": "gazettePublications.21.publicationDate",
                "value": "2013-08-27T00:00:00Z"
            },
            {
                "key": "gazettePublications.21.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.21.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.21.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS<\/b><\/center>10846 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>269 rue Georges Charpak   74100 Juvigny. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2012."
            },
            {
                "key": "gazettePublications.21.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE DE THONON-LES-BAINS\n10846 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 269 rue Georges Charpak   74100 Juvigny. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2012."
            },
            {
                "key": "gazettePublications.21.publicationID",
                "value": "7402472140000001084620130056NEW"
            },
            {
                "key": "gazettePublications.22.publicationDate",
                "value": "2013-02-06T00:00:00Z"
            },
            {
                "key": "gazettePublications.22.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.22.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.22.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>2197 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Activit\u00e9 : <\/i> . <i>Adresse de l\u2019\u00e9tablissement principal : <\/i>269 rue Georges Charpak, 74100 Juvigny. <br><i>Adresse du si\u00e8ge social : <\/i>269 rue Georges Charpak, 74100 Juvigny. <br><i>Commentaires : <\/i>Transfert du si\u00e8ge social, transfert de l'\u00e9tablissement principal."
            },
            {
                "key": "gazettePublications.22.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n2197 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Activit\u00e9 :  . Adresse de l\u2019\u00e9tablissement principal : 269 rue Georges Charpak, 74100 Juvigny. Adresse du si\u00e8ge social : 269 rue Georges Charpak, 74100 Juvigny. Commentaires : Transfert du si\u00e8ge social, transfert de l'\u00e9tablissement principal."
            },
            {
                "key": "gazettePublications.22.publicationID",
                "value": "BXB13030001344D219720130026NEW"
            },
            {
                "key": "gazettePublications.23.publicationDate",
                "value": "2013-01-07T00:00:00Z"
            },
            {
                "key": "gazettePublications.23.eventDate",
                "value": "2012-11-30T00:00:00Z"
            },
            {
                "key": "gazettePublications.23.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.23.description",
                "value": "Head Office Transfer"
            },
            {
                "key": "gazettePublications.23.details",
                "value": "<center><b>Progr\u00e8s (Le) Tribune-(La)\/Edition de la Haute Loire<\/b><\/center><br \/><i>Date de d\u00e9cision : <\/i>30\/11\/2012<br \/><I> Transfert du si\u00e8ge social de la soci\u00e9t\u00e9 <\/I>712023043 -\u00a0 LABLABO  <br\/><i> Adresse du nouveau si\u00e8ge : <\/i> 269 RUE GEORGES CHARPAK, 74100 JUVIGNY<Br\/><i> Ancienne localisation : <\/i>1 RUE DE L INDUSTRIE, ZI DU MONT BLANC, 74100 ANNEMASSE<br\/><b><i>Date d'effet : <\/i> 02\/01\/2013<\/b><br \/>"
            },
            {
                "key": "gazettePublications.23.publicationID",
                "value": "K\/3207496\/712023043\/4110\/07-01-2013"
            },
            {
                "key": "gazettePublications.24.publicationDate",
                "value": "2012-07-31T00:00:00Z"
            },
            {
                "key": "gazettePublications.24.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.24.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.24.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>11634 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>1 rue de l'Industrie Zone Industrielle du Mont Blanc    74100 Annemasse. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2011."
            },
            {
                "key": "gazettePublications.24.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n11634 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 1 rue de l'Industrie Zone Industrielle du Mont Blanc    74100 Annemasse. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2011."
            },
            {
                "key": "gazettePublications.24.publicationID",
                "value": "BXC1220201195371163420120045NEW"
            },
            {
                "key": "gazettePublications.25.publicationDate",
                "value": "2011-09-13T00:00:00Z"
            },
            {
                "key": "gazettePublications.25.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.25.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.25.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>9152 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>1 rue de l'Industrie Zone Industrielle du Mont Blanc    74100 Annemasse. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2010."
            },
            {
                "key": "gazettePublications.25.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n9152 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 1 rue de l'Industrie Zone Industrielle du Mont Blanc    74100 Annemasse. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2010."
            },
            {
                "key": "gazettePublications.25.publicationID",
                "value": "BXC11248000574V915220110059NEW"
            },
            {
                "key": "gazettePublications.26.publicationDate",
                "value": "2011-09-04T00:00:00Z"
            },
            {
                "key": "gazettePublications.26.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.26.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.26.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>1109 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Administration : <\/i>Pr\u00e9sident directeur g\u00e9n\u00e9ral : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Fran\u00e7oise, Andr\u00e9e n\u00e9(e) JEAN Administrateur : TABERLET J\u00e9r\u00e9mie Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. <i>Activit\u00e9 : <\/i> . <br><i>Commentaires : <\/i>Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.26.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n1109 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Administration : Pr\u00e9sident directeur g\u00e9n\u00e9ral : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Fran\u00e7oise, Andr\u00e9e n\u00e9(e) JEAN Administrateur : TABERLET J\u00e9r\u00e9mie Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. Activit\u00e9 :  . Commentaires : Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.26.publicationID",
                "value": "BXB11241000145L110920110171NEW"
            },
            {
                "key": "gazettePublications.27.publicationDate",
                "value": "2011-07-21T00:00:00Z"
            },
            {
                "key": "gazettePublications.27.eventDate",
                "value": "2011-06-23T00:00:00Z"
            },
            {
                "key": "gazettePublications.27.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.27.description",
                "value": "Resignation \/ Revocation of the social representative"
            },
            {
                "key": "gazettePublications.27.details",
                "value": "<center><b>Faucigny (Le)<\/b><\/center><br \/><i>Date de d\u00e9cision : <\/i>23\/06\/2011<br \/><i>La soci\u00e9t\u00e9 <\/i>712023043 - LABLABO, 1 RUE DE L INDUSTRIE, ZI DU MONT BLANC, 74100 ANNEMASSE <br\/><i>Fait l'objet du d\u00e9part de <\/i> <b><i>Date d'effet : <\/i> 23\/06\/2011<\/b><br\/>"
            },
            {
                "key": "gazettePublications.27.publicationID",
                "value": "K\/1745121\/712023043\/4109\/21-07-2011"
            },
            {
                "key": "gazettePublications.28.publicationDate",
                "value": "2011-07-21T00:00:00Z"
            },
            {
                "key": "gazettePublications.28.eventDate",
                "value": "2011-06-23T00:00:00Z"
            },
            {
                "key": "gazettePublications.28.gazetteName",
                "value": "JAL"
            },
            {
                "key": "gazettePublications.28.description",
                "value": "Appointment of the social representative"
            },
            {
                "key": "gazettePublications.28.details",
                "value": "<center><b>Faucigny (Le)<\/b><\/center><br \/><i>Soci\u00e9t\u00e9 faisant l'objet d'une nomination : <\/i>712023043 - LABLABO, 1 RUE DE L INDUSTRIE, ZI DU MONT BLANC, 74100 ANNEMASSE <br\/><i> Nomin\u00e9 : <\/i>Monsieur J\u00e9r\u00e9mie TABERLET, 74250 FILLINGES<br\/><i> En la fonction de : <\/i>Administrateur<br\/><b><i>Date d'effet : <\/i> 23\/06\/2011<\/b><br\/>"
            },
            {
                "key": "gazettePublications.28.publicationID",
                "value": "K\/1746160\/712023043\/4108\/21-07-2011"
            },
            {
                "key": "gazettePublications.29.publicationDate",
                "value": "2010-09-14T00:00:00Z"
            },
            {
                "key": "gazettePublications.29.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.29.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.29.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>4961 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>1 rue de l'Industrie Zone Industrielle du Mont Blanc    74100 Annemasse. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2009."
            },
            {
                "key": "gazettePublications.29.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n4961 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 1 rue de l'Industrie Zone Industrielle du Mont Blanc    74100 Annemasse. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2009."
            },
            {
                "key": "gazettePublications.29.publicationID",
                "value": "BXC10231005537G496120100061NEW"
            },
            {
                "key": "gazettePublications.30.publicationDate",
                "value": "2010-08-22T00:00:00Z"
            },
            {
                "key": "gazettePublications.30.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.30.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.30.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>1175 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Administration : <\/i>Pr\u00e9sident directeur g\u00e9n\u00e9ral : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Marie-C\u00e9line, Eva Administrateur : TABERLET Fran\u00e7oise, Andr\u00e9e n\u00e9(e) JEAN Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. <br><i>Commentaires : <\/i>Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.30.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n1175 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Administration : Pr\u00e9sident directeur g\u00e9n\u00e9ral : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Marie-C\u00e9line, Eva Administrateur : TABERLET Fran\u00e7oise, Andr\u00e9e n\u00e9(e) JEAN Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. Commentaires : Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.30.publicationID",
                "value": "BXB10228000864E117520100162NEW"
            },
            {
                "key": "gazettePublications.31.publicationDate",
                "value": "2009-11-30T00:00:00Z"
            },
            {
                "key": "gazettePublications.31.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.31.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.31.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>1959 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Administration : <\/i>Pr\u00e9sident directeur g\u00e9n\u00e9ral : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Benjamin Administrateur : TABERLET Marie-C\u00e9line Eva Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. <br><i>Commentaires : <\/i>Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.31.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n1959 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Administration : Pr\u00e9sident directeur g\u00e9n\u00e9ral : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Benjamin Administrateur : TABERLET Marie-C\u00e9line Eva Commissaire aux comptes titulaire : RSM CCI CONSEILS repr\u00e9sent\u00e9 par MONNERET Pierre Commissaire aux comptes suppl\u00e9ant : PENNEQUIN Jean-Marc. Commentaires : Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.31.publicationID",
                "value": "BXB09324002878E195920090230NEW"
            },
            {
                "key": "gazettePublications.32.publicationDate",
                "value": "2009-08-26T00:00:00Z"
            },
            {
                "key": "gazettePublications.32.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.32.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.32.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>11344 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>1 rue de l'Industrie Zone Industrielle du Mont Blanc    74100 Annemasse. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2008."
            },
            {
                "key": "gazettePublications.32.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n11344 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 1 rue de l'Industrie Zone Industrielle du Mont Blanc    74100 Annemasse. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2008."
            },
            {
                "key": "gazettePublications.32.publicationID",
                "value": "BXC0823100946991134420090059NEW"
            },
            {
                "key": "gazettePublications.33.publicationDate",
                "value": "2009-08-13T00:00:00Z"
            },
            {
                "key": "gazettePublications.33.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.33.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.33.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>701 - 712 023 043 RCS Thonon-les-Bains. <b>LABLABO. <\/b><i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Administration : <\/i>Pr\u00e9sident directeur g\u00e9n\u00e9ral : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Benjamin Administrateur : TABERLET Marie-C\u00e9line Eva Commissaire aux comptes titulaire : COMPAGNIE EUROPEENNE DE REVISION ET D'AUDIT (SARL) Commissaire aux comptes suppl\u00e9ant : SALLE DE CHOU Philippe. <br><i>Commentaires : <\/i>Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.33.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n701 - 712 023 043 RCS Thonon-les-Bains. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Administration : Pr\u00e9sident directeur g\u00e9n\u00e9ral : TABERLET Jean-Philippe, Marie Administrateur : TABERLET Benjamin Administrateur : TABERLET Marie-C\u00e9line Eva Commissaire aux comptes titulaire : COMPAGNIE EUROPEENNE DE REVISION ET D'AUDIT (SARL) Commissaire aux comptes suppl\u00e9ant : SALLE DE CHOU Philippe. Commentaires : Modification survenue sur l'administration."
            },
            {
                "key": "gazettePublications.33.publicationID",
                "value": "BXB08219003853N70120090154NEW"
            },
            {
                "key": "gazettePublications.34.publicationDate",
                "value": "2009-06-24T00:00:00Z"
            },
            {
                "key": "gazettePublications.34.gazetteName",
                "value": "Bodacc C"
            },
            {
                "key": "gazettePublications.34.description",
                "value": "Comptes annuels et rapports"
            },
            {
                "key": "gazettePublications.34.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS<\/b><\/center>8159 - 712023043 RCS. <b>LABLABO<\/b>. <i>Forme : <\/i>Soci\u00e9t\u00e9 anonyme. <i>Adresse : <\/i>1 rue de l'Industrie Zone Industrielle du Mont Blanc,   74100 Annemasse. <i>Commentaires :<\/i> Comptes annuels et rapports de l'exercice clos le : 31\/12\/2007."
            },
            {
                "key": "gazettePublications.34.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE COMMERCE\nDE THONON-LES-BAINS\n8159 - 712023043 RCS. LABLABO. Forme : Soci\u00e9t\u00e9 anonyme. Adresse : 1 rue de l'Industrie Zone Industrielle du Mont Blanc,   74100 Annemasse. Commentaires : Comptes annuels et rapports de l'exercice clos le : 31\/12\/2007."
            },
            {
                "key": "gazettePublications.34.publicationID",
                "value": "BXC08167014947X815920090040NEW"
            },
            {
                "key": "gazettePublications.35.publicationDate",
                "value": "2008-12-09T00:00:00Z"
            },
            {
                "key": "gazettePublications.35.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.35.description",
                "value": "Modification et mutation diverse"
            },
            {
                "key": "gazettePublications.35.details",
                "value": "<center><b>74 - HAUTE-SAVOIE<\/b><\/center><center><b>GREFFE DU TRIBUNAL DE GRANDE INSTANCE\nDE THONON-LES-BAINS<\/b><\/center>873 - 712 023 043 RCS Thonon. <b>LABLABO. <\/b><i>Forme : <\/i>S.A. <i>Capital : <\/i>43200 EUR. <br><i>Adresse du si\u00e8ge social : <\/i>1 rue de l'Industrie, ZI du Mont-Blanc, 74100 Annemasse. <br><i>Commentaires : <\/i>r\u00e9duction du capital il a \u00e9t\u00e9 d\u00e9cid\u00e9 de r\u00e9duire le capital social de 7 800 euros pour le ramener de 48 000 euros \u00e0 43 200 euros ; date d'effet : 16\/09\/2008."
            },
            {
                "key": "gazettePublications.35.fullContent",
                "value": "74 - HAUTE-SAVOIE\nGREFFE DU TRIBUNAL DE GRANDE INSTANCE\nDE THONON-LES-BAINS\n873 - 712 023 043 RCS Thonon. LABLABO. Forme : S.A. Capital : 43200 EUR. Adresse du si\u00e8ge social : 1 rue de l'Industrie, ZI du Mont-Blanc, 74100 Annemasse. Commentaires : r\u00e9duction du capital il a \u00e9t\u00e9 d\u00e9cid\u00e9 de r\u00e9duire le capital social de 7 800 euros pour le ramener de 48 000 euros \u00e0 43 200 euros ; date d'effet : 16\/09\/2008."
            },
            {
                "key": "gazettePublications.35.publicationID",
                "value": "BXB08339000235687320080225NEW"
            },
            {
                "key": "gazettePublications.36.publicationDate",
                "value": "2007-05-03T00:00:00Z"
            },
            {
                "key": "gazettePublications.36.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.36.description",
                "value": "Modifications et mutations diverses"
            },
            {
                "key": "gazettePublications.36.details",
                "value": "1225 - RCS Thonon-les-Bains 712 023 043. RC 84-B 46. LABLABO. Forme : S.A. Capital : 48 000 euros. Adresse du si\u00e8ge social : Z.I. du Mont Blanc, 1 rue de l'Industrie,, 74100 Administration : ancien pr\u00e9sident qui reste administrateur : MONDUC, n\u00e9e SUCK (Isabelle). Nouveau pr\u00e9sident du conseil d'administration : TABERLET (Jean-Philippe), d\u00e9j\u00e0 directeur g\u00e9n\u00e9ral et administrateur. Date d'effet : 15 f\u00e9vrier 2007."
            },
            {
                "key": "gazettePublications.36.fullContent",
                "value": "1225 - RCS Thonon-les-Bains 712 023 043. RC 84-B 46. LABLABO. Forme : S.A. Capital : 48 000 euros. Adresse du si\u00e8ge social : Z.I. du Mont Blanc, 1 rue de l'Industrie,, 74100 Administration : ancien pr\u00e9sident qui reste administrateur : MONDUC, n\u00e9e SUCK (Isabelle). Nouveau pr\u00e9sident du conseil d'administration : TABERLET (Jean-Philippe), d\u00e9j\u00e0 directeur g\u00e9n\u00e9ral et administrateur. Date d'effet : 15 f\u00e9vrier 2007."
            },
            {
                "key": "gazettePublications.36.publicationID",
                "value": "BXB0001780980122520070085NEW"
            },
            {
                "key": "gazettePublications.37.publicationDate",
                "value": "2006-04-25T00:00:00Z"
            },
            {
                "key": "gazettePublications.37.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.37.description",
                "value": "Modifications et mutations diverses"
            },
            {
                "key": "gazettePublications.37.details",
                "value": "1893 - RCS Thonon-les-Bains 712 023 043. RC 84-B 46. LABLABO. Forme : S.A. Capital : 48 000 euros. Adresse du si\u00e8ge social : Z.I. du Mont Blanc, 1 rue de l'Industrie,, 74100 Administration : ancien administrateur : SUCK (Pierre). Date d'effet : 8 juin 2005."
            },
            {
                "key": "gazettePublications.37.fullContent",
                "value": "1893 - RCS Thonon-les-Bains 712 023 043. RC 84-B 46. LABLABO. Forme : S.A. Capital : 48 000 euros. Adresse du si\u00e8ge social : Z.I. du Mont Blanc, 1 rue de l'Industrie,, 74100 Administration : ancien administrateur : SUCK (Pierre). Date d'effet : 8 juin 2005."
            },
            {
                "key": "gazettePublications.37.publicationID",
                "value": "BXB0001141236189320060080NEW"
            },
            {
                "key": "gazettePublications.38.publicationDate",
                "value": "2003-08-10T00:00:00Z"
            },
            {
                "key": "gazettePublications.38.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.38.description",
                "value": "Modifications et mutations diverses"
            },
            {
                "key": "gazettePublications.38.details",
                "value": "RCS Thonon-les-Bains 712023043 RC 84-B 46 LABLABO. Forme : S.A. Capital : 48 000 euros. Adresse du si\u00e8ge social : Z.I. du Mont Blanc, 1 rue de l'Industrie, 74100 Annemasse. Administration : nouvel administrateur : TABERLET (Jean- Philippe), d\u00e9j\u00e0 directeur g\u00e9n\u00e9ral. Nomination de MONDUC (Max), en qualit\u00e9 d'administrateur, suite au d\u00e9part de M m e MONDUC (Marie, Ren\u00e9e). Nomination de la S.A.R.L. COMPAGNIE EUROPEENNE DE REVISION ET D'AUDIT, en qualit\u00e9 de commissaire aux comptes titulaire, suite au d\u00e9part de MEYER (David). Nomination de SALLE DE CHOU (Philippe), en qualit\u00e9 de commissaire aux comptes suppl\u00e9ant, suite au d\u00e9part de la FIDUCIAIRE CONTINENTALE GRENOBLE. Date d'effet : 24 juin 2003."
            },
            {
                "key": "gazettePublications.38.fullContent",
                "value": "RCS Thonon-les-Bains 712023043 RC 84-B 46 LABLABO. Forme : S.A. Capital : 48 000 euros. Adresse du si\u00e8ge social : Z.I. du Mont Blanc, 1 rue de l'Industrie, 74100 Annemasse. Administration : nouvel administrateur : TABERLET (Jean- Philippe), d\u00e9j\u00e0 directeur g\u00e9n\u00e9ral. Nomination de MONDUC (Max), en qualit\u00e9 d'administrateur, suite au d\u00e9part de M m e MONDUC (Marie, Ren\u00e9e). Nomination de la S.A.R.L. COMPAGNIE EUROPEENNE DE REVISION ET D'AUDIT, en qualit\u00e9 de commissaire aux comptes titulaire, suite au d\u00e9part de MEYER (David). Nomination de SALLE DE CHOU (Philippe), en qualit\u00e9 de commissaire aux comptes suppl\u00e9ant, suite au d\u00e9part de la FIDUCIAIRE CONTINENTALE GRENOBLE. Date d'effet : 24 juin 2003."
            },
            {
                "key": "gazettePublications.38.publicationID",
                "value": "BXB0026766998160720030151NEW"
            },
            {
                "key": "gazettePublications.39.publicationDate",
                "value": "2001-10-09T00:00:00Z"
            },
            {
                "key": "gazettePublications.39.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.39.description",
                "value": "Modifications et mutations diverses"
            },
            {
                "key": "gazettePublications.39.details",
                "value": "Ancienne situation du si\u00e8ge social. RCS Thonon-les-Bains B 712023043 RC 84-B 46 LABLABO. Forme : S.A. Capital : 300 000 F. Adresse : Z.I. du Mont Blanc, 1 rue de l' Industrie, 74100 Annemasse Nouvelle situation du si\u00e8ge social. Capital : 48 000 euros. Commentaires : conversion du capital pour le porter de 300 000 F \u00e0 45 734,71 euros puis augmentation. Date d'effet : 26 juin 2001."
            },
            {
                "key": "gazettePublications.39.fullContent",
                "value": "Ancienne situation du si\u00e8ge social. RCS Thonon-les-Bains B 712023043 RC 84-B 46 LABLABO. Forme : S.A. Capital : 300 000 F. Adresse : Z.I. du Mont Blanc, 1 rue de l' Industrie, 74100 Annemasse Nouvelle situation du si\u00e8ge social. Capital : 48 000 euros. Commentaires : conversion du capital pour le porter de 300 000 F \u00e0 45 734,71 euros puis augmentation. Date d'effet : 26 juin 2001."
            },
            {
                "key": "gazettePublications.39.publicationID",
                "value": "BXB0020905692164720010199NEW"
            },
            {
                "key": "gazettePublications.40.publicationDate",
                "value": "1999-07-31T00:00:00Z"
            },
            {
                "key": "gazettePublications.40.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.40.description",
                "value": "Modifications et mutations diverses"
            },
            {
                "key": "gazettePublications.40.details",
                "value": "Additif: Annonce num\u00e9ro: 1878 Date de parution: 10 avril 1999 Page: 90 Num\u00e9ro de parution: 70 B Apr\u00e8s la date de radiation, ajouter : c'est par erreur que ce num\u00e9ro a \u00e9t\u00e9 attribu\u00e9. Il s' agissait d'un transfert dans l' \u00e9tablissement secondaire et non d'une immatriculation. Voir RC 84-B 46. RCS Thonon-les-Bains B 712023043 RC 99-B 45 LABLABO Date de radiation: 9 mars 1999. Commentaires : c'est par erreur que ce num\u00e9ro a \u00e9t\u00e9 attribu\u00e9. Il s'agissait d' un transfert dans l'\u00e9tablissement secondaire et non d'une immatriculation. Voir RC 84-B 46."
            },
            {
                "key": "gazettePublications.40.fullContent",
                "value": "Additif: Annonce num\u00e9ro: 1878 Date de parution: 10 avril 1999 Page: 90 Num\u00e9ro de parution: 70 B Apr\u00e8s la date de radiation, ajouter : c'est par erreur que ce num\u00e9ro a \u00e9t\u00e9 attribu\u00e9. Il s' agissait d'un transfert dans l' \u00e9tablissement secondaire et non d'une immatriculation. Voir RC 84-B 46. RCS Thonon-les-Bains B 712023043 RC 99-B 45 LABLABO Date de radiation: 9 mars 1999. Commentaires : c'est par erreur que ce num\u00e9ro a \u00e9t\u00e9 attribu\u00e9. Il s'agissait d' un transfert dans l'\u00e9tablissement secondaire et non d'une immatriculation. Voir RC 84-B 46."
            },
            {
                "key": "gazettePublications.40.publicationID",
                "value": "BXB001472686188519990147NEW"
            },
            {
                "key": "gazettePublications.41.publicationDate",
                "value": "1999-04-10T00:00:00Z"
            },
            {
                "key": "gazettePublications.41.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.41.description",
                "value": "Modifications et mutations diverses"
            },
            {
                "key": "gazettePublications.41.details",
                "value": "RCS Thonon-les-Bains B 712 023 043 RC 99-B 45 LABLABO. Forme : S.A. Activit\u00e9 : fabrication, vente de syst\u00e8mes de dosage adaptables sur tous r\u00e9cipients et destin\u00e9s \u00e0 tous usages. Adresse du si\u00e8ge social : Z.I. du Mont Blanc, 1 rue de l'Industrie 74100 Annemasse Date de radiation: 9 mars 1999."
            },
            {
                "key": "gazettePublications.41.fullContent",
                "value": "RCS Thonon-les-Bains B 712 023 043 RC 99-B 45 LABLABO. Forme : S.A. Activit\u00e9 : fabrication, vente de syst\u00e8mes de dosage adaptables sur tous r\u00e9cipients et destin\u00e9s \u00e0 tous usages. Adresse du si\u00e8ge social : Z.I. du Mont Blanc, 1 rue de l'Industrie 74100 Annemasse Date de radiation: 9 mars 1999."
            },
            {
                "key": "gazettePublications.41.publicationID",
                "value": "BXB0014407387187819990070NEW"
            },
            {
                "key": "gazettePublications.42.publicationDate",
                "value": "1999-03-11T00:00:00Z"
            },
            {
                "key": "gazettePublications.42.gazetteName",
                "value": "Bodacc B"
            },
            {
                "key": "gazettePublications.42.description",
                "value": "Modifications et mutations diverses"
            },
            {
                "key": "gazettePublications.42.details",
                "value": "RCS Thonon-les-Bains B 421 456 856 A dater du: 4 f\u00e9vrier 1999 RC 99-B 45 LABLADO. Forme : S.A. Capital : 300 000 F ( fixe). Adresse du si\u00e8ge social : 1 rue de l'Industrie, Z.I. du Mont-Blanc, 74100 Annemasse. Commentaires : transfert du si\u00e8ge social et de l'\u00e9tablissement principal du 13 avenue Morane Saulnier, 78140 V\u00e9lizy Villacoublay. Administration : pr\u00e9sident du conseil d' administration : Mme SUCK (Isabelle), nom d'usage : MONDUC directeur g\u00e9n\u00e9ral : TABERLET (Jean-Philippe, Marie) administrateurs : SUCK (Pierre, Jean), Mme MONDUC (Marie, Ren\u00e9e) commissaire aux comptes titulaire : MEYER (David) commissaire aux comptes suppl\u00e9ant : FIDUCIAIRE CONTINENTALE GRENOBLE Etablissement principal: Activit\u00e9 : fabrication et vente de syst\u00e8mes de dosage adaptables sur tous r\u00e9cipients et destin\u00e9s \u00e0 tous usages. Adresse : 1 rue de l'Industrie, Z.I. du Mont-Blanc, 74100 Annemasse. Date d'effet : 8 d\u00e9cembre 1998."
            },
            {
                "key": "gazettePublications.42.fullContent",
                "value": "RCS Thonon-les-Bains B 421 456 856 A dater du: 4 f\u00e9vrier 1999 RC 99-B 45 LABLADO. Forme : S.A. Capital : 300 000 F ( fixe). Adresse du si\u00e8ge social : 1 rue de l'Industrie, Z.I. du Mont-Blanc, 74100 Annemasse. Commentaires : transfert du si\u00e8ge social et de l'\u00e9tablissement principal du 13 avenue Morane Saulnier, 78140 V\u00e9lizy Villacoublay. Administration : pr\u00e9sident du conseil d' administration : Mme SUCK (Isabelle), nom d'usage : MONDUC directeur g\u00e9n\u00e9ral : TABERLET (Jean-Philippe, Marie) administrateurs : SUCK (Pierre, Jean), Mme MONDUC (Marie, Ren\u00e9e) commissaire aux comptes titulaire : MEYER (David) commissaire aux comptes suppl\u00e9ant : FIDUCIAIRE CONTINENTALE GRENOBLE Etablissement principal: Activit\u00e9 : fabrication et vente de syst\u00e8mes de dosage adaptables sur tous r\u00e9cipients et destin\u00e9s \u00e0 tous usages. Adresse : 1 rue de l'Industrie, Z.I. du Mont-Blanc, 74100 Annemasse. Date d'effet : 8 d\u00e9cembre 1998."
            },
            {
                "key": "gazettePublications.42.publicationID",
                "value": "BXB0015255016138219990048NEW"
            },
            {
                "key": "commentaries.0.commentaryText",
                "value": "Financial statements overdue. The latest Creditsafe risk score has taken this into account, please contact Creditsafe with your latest financial statements if you want the risk score to be recalculated"
            },
            {
                "key": "commentaries.0.positiveOrNegative",
                "value": "Negative"
            },
            {
                "key": "commentaries.1.commentaryText",
                "value": "Industry code with medium risk level, given the company's size"
            },
            {
                "key": "commentaries.1.positiveOrNegative",
                "value": "Neutral"
            },
            {
                "key": "commentaries.2.commentaryText",
                "value": "Registered capital is 43200 \u20ac"
            },
            {
                "key": "commentaries.2.positiveOrNegative",
                "value": "Positive"
            },
            {
                "key": "commentaries.3.commentaryText",
                "value": "The company is 53 years old"
            },
            {
                "key": "commentaries.3.positiveOrNegative",
                "value": "Positive"
            },
            {
                "key": "ratingHistory.0.date",
                "value": "2024-10-30T00:00:00Z"
            },
            {
                "key": "ratingHistory.0.localRating",
                "value": "36"
            },
            {
                "key": "ratingHistory.0.commonRating.commonValue",
                "value": "C"
            },
            {
                "key": "ratingHistory.0.commonRating.commonDescription",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.0.description2",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.0.limit",
                "value": "7750"
            },
            {
                "key": "ratingHistory.1.date",
                "value": "2024-06-04T00:00:00Z"
            },
            {
                "key": "ratingHistory.1.localRating",
                "value": "47"
            },
            {
                "key": "ratingHistory.1.commonRating.commonValue",
                "value": "C"
            },
            {
                "key": "ratingHistory.1.commonRating.commonDescription",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.1.description2",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.1.limit",
                "value": "8750"
            },
            {
                "key": "ratingHistory.2.date",
                "value": "2022-09-24T00:00:00Z"
            },
            {
                "key": "ratingHistory.2.localRating",
                "value": "47"
            },
            {
                "key": "ratingHistory.2.commonRating.commonValue",
                "value": "C"
            },
            {
                "key": "ratingHistory.2.commonRating.commonDescription",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.2.description2",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.2.limit",
                "value": "17250"
            },
            {
                "key": "ratingHistory.3.date",
                "value": "2021-09-25T00:00:00Z"
            },
            {
                "key": "ratingHistory.3.localRating",
                "value": "40"
            },
            {
                "key": "ratingHistory.3.commonRating.commonValue",
                "value": "C"
            },
            {
                "key": "ratingHistory.3.commonRating.commonDescription",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.3.description2",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.3.limit",
                "value": "17250"
            },
            {
                "key": "ratingHistory.4.date",
                "value": "2021-05-07T00:00:00Z"
            },
            {
                "key": "ratingHistory.4.localRating",
                "value": "36"
            },
            {
                "key": "ratingHistory.4.commonRating.commonValue",
                "value": "C"
            },
            {
                "key": "ratingHistory.4.commonRating.commonDescription",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.4.description2",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.4.limit",
                "value": "15500"
            },
            {
                "key": "ratingHistory.5.date",
                "value": "2019-11-05T00:00:00Z"
            },
            {
                "key": "ratingHistory.5.localRating",
                "value": "97"
            },
            {
                "key": "ratingHistory.5.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.5.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.5.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.5.limit",
                "value": "880000"
            },
            {
                "key": "ratingHistory.6.date",
                "value": "2019-07-02T00:00:00Z"
            },
            {
                "key": "ratingHistory.6.localRating",
                "value": "98"
            },
            {
                "key": "ratingHistory.6.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.6.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.6.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.6.limit",
                "value": "890000"
            },
            {
                "key": "ratingHistory.7.date",
                "value": "2018-07-14T00:00:00Z"
            },
            {
                "key": "ratingHistory.7.localRating",
                "value": "97"
            },
            {
                "key": "ratingHistory.7.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.7.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.7.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.7.limit",
                "value": "775000"
            },
            {
                "key": "ratingHistory.8.date",
                "value": "2018-03-24T00:00:00Z"
            },
            {
                "key": "ratingHistory.8.localRating",
                "value": "97"
            },
            {
                "key": "ratingHistory.8.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.8.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.8.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.8.limit",
                "value": "600000"
            },
            {
                "key": "ratingHistory.9.date",
                "value": "2018-01-18T00:00:00Z"
            },
            {
                "key": "ratingHistory.9.localRating",
                "value": "93"
            },
            {
                "key": "ratingHistory.9.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.9.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.9.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.9.limit",
                "value": "575000"
            },
            {
                "key": "ratingHistory.10.date",
                "value": "2017-08-03T00:00:00Z"
            },
            {
                "key": "ratingHistory.10.localRating",
                "value": "94"
            },
            {
                "key": "ratingHistory.10.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.10.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.10.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.10.limit",
                "value": "585000"
            },
            {
                "key": "ratingHistory.11.date",
                "value": "2017-04-06T00:00:00Z"
            },
            {
                "key": "ratingHistory.11.localRating",
                "value": "95"
            },
            {
                "key": "ratingHistory.11.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.11.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.11.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.11.limit",
                "value": "520000"
            },
            {
                "key": "ratingHistory.12.date",
                "value": "2016-12-11T00:00:00Z"
            },
            {
                "key": "ratingHistory.12.localRating",
                "value": "94"
            },
            {
                "key": "ratingHistory.12.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.12.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.12.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.12.limit",
                "value": "545000"
            },
            {
                "key": "ratingHistory.13.date",
                "value": "2015-11-28T00:00:00Z"
            },
            {
                "key": "ratingHistory.13.localRating",
                "value": "88"
            },
            {
                "key": "ratingHistory.13.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.13.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.13.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.13.limit",
                "value": "510000"
            },
            {
                "key": "ratingHistory.14.date",
                "value": "2015-10-03T00:00:00Z"
            },
            {
                "key": "ratingHistory.14.localRating",
                "value": "85"
            },
            {
                "key": "ratingHistory.14.commonRating.commonValue",
                "value": "A"
            },
            {
                "key": "ratingHistory.14.commonRating.commonDescription",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.14.description2",
                "value": "Very Low Risk"
            },
            {
                "key": "ratingHistory.14.limit",
                "value": "490000"
            },
            {
                "key": "ratingHistory.15.date",
                "value": "2015-01-01T00:00:00Z"
            },
            {
                "key": "ratingHistory.15.localRating",
                "value": "68"
            },
            {
                "key": "ratingHistory.15.commonRating.commonValue",
                "value": "B"
            },
            {
                "key": "ratingHistory.15.commonRating.commonDescription",
                "value": "Low Risk"
            },
            {
                "key": "ratingHistory.15.description2",
                "value": "Low Risk"
            },
            {
                "key": "ratingHistory.15.limit",
                "value": "260000"
            },
            {
                "key": "ratingHistory.16.date",
                "value": "2014-02-08T00:00:00Z"
            },
            {
                "key": "ratingHistory.16.localRating",
                "value": "60"
            },
            {
                "key": "ratingHistory.16.commonRating.commonValue",
                "value": "B"
            },
            {
                "key": "ratingHistory.16.commonRating.commonDescription",
                "value": "Low Risk"
            },
            {
                "key": "ratingHistory.16.description2",
                "value": "Low Risk"
            },
            {
                "key": "ratingHistory.16.limit",
                "value": "155000"
            },
            {
                "key": "ratingHistory.17.date",
                "value": "2013-10-19T00:00:00Z"
            },
            {
                "key": "ratingHistory.17.localRating",
                "value": "57"
            },
            {
                "key": "ratingHistory.17.commonRating.commonValue",
                "value": "B"
            },
            {
                "key": "ratingHistory.17.commonRating.commonDescription",
                "value": "Low Risk"
            },
            {
                "key": "ratingHistory.17.description2",
                "value": "Low Risk"
            },
            {
                "key": "ratingHistory.17.limit",
                "value": "145000"
            },
            {
                "key": "ratingHistory.18.date",
                "value": "2013-08-13T00:00:00Z"
            },
            {
                "key": "ratingHistory.18.localRating",
                "value": "35"
            },
            {
                "key": "ratingHistory.18.commonRating.commonValue",
                "value": "C"
            },
            {
                "key": "ratingHistory.18.commonRating.commonDescription",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.18.description2",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.18.limit",
                "value": "60000"
            },
            {
                "key": "ratingHistory.19.localRating",
                "value": "35"
            },
            {
                "key": "ratingHistory.19.commonRating.commonValue",
                "value": "C"
            },
            {
                "key": "ratingHistory.19.commonRating.commonDescription",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.19.description2",
                "value": "Moderate Risk"
            },
            {
                "key": "ratingHistory.19.limit",
                "value": "71000"
            },
            {
                "key": "industryAverages.creditLimit",
                "value": "139558"
            },
            {
                "key": "industryAverages.creditRating",
                "value": "51"
            },
            {
                "key": "keyFinancials.0.yearToDate",
                "value": "2018-12-31T00:00:00Z"
            },
            {
                "key": "keyFinancials.0.turnover",
                "value": "13360288"
            },
            {
                "key": "keyFinancials.0.grossOperatingSurplus",
                "value": "14.87"
            },
            {
                "key": "keyFinancials.0.shareholdersEquity",
                "value": "13739190"
            },
            {
                "key": "keyFinancials.0.netResult",
                "value": "1110167"
            },
            {
                "key": "keyFinancials.0.employees",
                "value": "69 employees"
            },
            {
                "key": "keyFinancials.1.yearToDate",
                "value": "2017-12-31T00:00:00Z"
            },
            {
                "key": "keyFinancials.1.turnover",
                "value": "13457286"
            },
            {
                "key": "keyFinancials.1.grossOperatingSurplus",
                "value": "14.43"
            },
            {
                "key": "keyFinancials.1.shareholdersEquity",
                "value": "12652035"
            },
            {
                "key": "keyFinancials.1.netResult",
                "value": "1080163"
            },
            {
                "key": "keyFinancials.1.employees",
                "value": "39 employees"
            },
            {
                "key": "keyFinancials.2.yearToDate",
                "value": "2016-12-31T00:00:00Z"
            },
            {
                "key": "keyFinancials.2.turnover",
                "value": "12011093"
            },
            {
                "key": "keyFinancials.2.grossOperatingSurplus",
                "value": "12.61"
            },
            {
                "key": "keyFinancials.2.shareholdersEquity",
                "value": "11733760"
            },
            {
                "key": "keyFinancials.2.netResult",
                "value": "819860"
            },
            {
                "key": "keyFinancials.2.employees",
                "value": "50 to 99 employees"
            },
            {
                "key": "branches.0.id",
                "value": "FR-X-71202304300052"
            },
            {
                "key": "branches.0.companyNumber",
                "value": "71202304300052"
            },
            {
                "key": "branches.0.companyName",
                "value": "LABLABO"
            },
            {
                "key": "branches.0.type",
                "value": "Head Office"
            },
            {
                "key": "branches.0.lineOfBusiness",
                "value": "Manufacture of plastic packing goods"
            },
            {
                "key": "branches.0.status",
                "value": "A"
            },
            {
                "key": "branches.0.isActive",
                "value": "1"
            },
            {
                "key": "branches.0.activityApe",
                "value": "2222Z"
            },
            {
                "key": "branches.0.name",
                "value": "LABLABO"
            },
            {
                "key": "branches.0.address.simpleValue",
                "value": "269 RUE GEORGES CHARPAK JUVIGNY 74100"
            },
            {
                "key": "branches.0.address.street",
                "value": "269 RUE GEORGES CHARPAK"
            },
            {
                "key": "branches.0.address.city",
                "value": "JUVIGNY"
            },
            {
                "key": "branches.0.address.postalCode",
                "value": "74100"
            },
            {
                "key": "branches.0.address.telephone",
                "value": "0450952090"
            },
            {
                "key": "branches.0.distribution",
                "value": "74100 JUVIGNY"
            },
            {
                "key": "branches.0.safeNumber",
                "value": "FR16259764"
            },
            {
                "key": "branches.1.id",
                "value": "FR-X-71202304300037"
            },
            {
                "key": "branches.1.companyNumber",
                "value": "71202304300037"
            },
            {
                "key": "branches.1.companyName",
                "value": "LABLABO"
            },
            {
                "key": "branches.1.type",
                "value": "Secondary establishment"
            },
            {
                "key": "branches.1.lineOfBusiness",
                "value": "Manufacture of plastic packing goods"
            },
            {
                "key": "branches.1.status",
                "value": "C"
            },
            {
                "key": "branches.1.isActive",
                "value": ""
            },
            {
                "key": "branches.1.activityApe",
                "value": "2222Z"
            },
            {
                "key": "branches.1.name",
                "value": "LABLABO"
            },
            {
                "key": "branches.1.address.simpleValue",
                "value": "1 RUE DE L\u2019INDUSTRIE ANNEMASSE 74100"
            },
            {
                "key": "branches.1.address.street",
                "value": "ZI DU MONT BLANC 1 RUE DE L INDUSTRIE"
            },
            {
                "key": "branches.1.address.city",
                "value": "ANNEMASSE"
            },
            {
                "key": "branches.1.address.postalCode",
                "value": "74100"
            },
            {
                "key": "branches.1.distribution",
                "value": "74100 ANNEMASSE"
            },
            {
                "key": "branches.1.safeNumber",
                "value": "FR11854351"
            },
            {
                "key": "branches.2.id",
                "value": "FR-X-71202304300011"
            },
            {
                "key": "branches.2.companyNumber",
                "value": "71202304300011"
            },
            {
                "key": "branches.2.companyName",
                "value": "LABLABO"
            },
            {
                "key": "branches.2.type",
                "value": "Secondary establishment"
            },
            {
                "key": "branches.2.lineOfBusiness",
                "value": "Manufacture of plastic packing goods"
            },
            {
                "key": "branches.2.status",
                "value": "C"
            },
            {
                "key": "branches.2.isActive",
                "value": ""
            },
            {
                "key": "branches.2.activityApe",
                "value": "2222Z"
            },
            {
                "key": "branches.2.name",
                "value": "LABLABO"
            },
            {
                "key": "branches.2.address.simpleValue",
                "value": "5 RUE ROGER SALENGRO MONTROUGE 92120"
            },
            {
                "key": "branches.2.address.city",
                "value": "MONTROUGE"
            },
            {
                "key": "branches.2.address.postalCode",
                "value": "92120"
            },
            {
                "key": "branches.2.distribution",
                "value": "92120 MONTROUGE"
            },
            {
                "key": "branches.2.safeNumber",
                "value": "FR29536637"
            },
            {
                "key": "branches.3.id",
                "value": "FR-X-71202304300045"
            },
            {
                "key": "branches.3.companyNumber",
                "value": "71202304300045"
            },
            {
                "key": "branches.3.companyName",
                "value": "LABLABO"
            },
            {
                "key": "branches.3.type",
                "value": "Secondary establishment"
            },
            {
                "key": "branches.3.lineOfBusiness",
                "value": "Manufacture of plastic packing goods"
            },
            {
                "key": "branches.3.status",
                "value": "C"
            },
            {
                "key": "branches.3.isActive",
                "value": ""
            },
            {
                "key": "branches.3.activityApe",
                "value": "2222Z"
            },
            {
                "key": "branches.3.name",
                "value": "LABLABO"
            },
            {
                "key": "branches.3.address.simpleValue",
                "value": "13 AV MORANE SAULNIER VELIZY-VILLACOUBLAY 78140"
            },
            {
                "key": "branches.3.address.city",
                "value": "VELIZY-VILLACOUBLAY"
            },
            {
                "key": "branches.3.address.postalCode",
                "value": "78140"
            },
            {
                "key": "branches.3.distribution",
                "value": "78140 VELIZY-VILLACOUBLAY"
            },
            {
                "key": "branches.3.safeNumber",
                "value": "FR29536638"
            },
            {
                "key": "enquiriesTrend.latestEnquiryDate",
                "value": "2026-02-23T07:28:08Z"
            },
            {
                "key": "enquiriesTrend.month1",
                "value": "1"
            },
            {
                "key": "enquiriesTrend.month2",
                "value": "2"
            },
            {
                "key": "enquiriesTrend.month3",
                "value": "1"
            },
            {
                "key": "enquiriesTrend.month4",
                "value": "3"
            },
            {
                "key": "enquiriesTrend.month5",
                "value": "0"
            },
            {
                "key": "enquiriesTrend.month6",
                "value": "4"
            },
            {
                "key": "enquiriesTrend.month7",
                "value": "1"
            },
            {
                "key": "enquiriesTrend.month8",
                "value": "1"
            },
            {
                "key": "enquiriesTrend.month9",
                "value": "0"
            },
            {
                "key": "enquiriesTrend.month10",
                "value": "1"
            },
            {
                "key": "enquiriesTrend.month11",
                "value": "0"
            },
            {
                "key": "enquiriesTrend.month12",
                "value": "0"
            },
            {
                "key": "enquiriesTrend.months1to3",
                "value": "4"
            },
            {
                "key": "enquiriesTrend.months4to6",
                "value": "7"
            },
            {
                "key": "enquiriesTrend.months7to9",
                "value": "2"
            },
            {
                "key": "enquiriesTrend.months10to12",
                "value": "1"
            },
            {
                "key": "enquiriesTrend.monthlyAverage",
                "value": "1"
            },
            {
                "key": "paymentExpectationsSummary.paymentExpectationDays",
                "value": "47"
            },
            {
                "key": "paymentExpectationsSummary.daySalesOutstanding",
                "value": "55"
            },
            {
                "key": "industryComparison.activityCode",
                "value": "2222Z"
            },
            {
                "key": "industryComparison.activityDescription",
                "value": "Manufacture of plastic packing goods"
            },
            {
                "key": "industryComparison.industryAveragePaymentExpectationDays",
                "value": "67.53"
            },
            {
                "key": "industryComparison.industryAverageDaySalesOutstanding",
                "value": "165.45"
            },
            {
                "key": "gpsCoordinates.xAxis",
                "value": "953276.52"
            },
            {
                "key": "gpsCoordinates.yAxis",
                "value": "6572925.63"
            }
        ]
    ));

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('general-info')}
            className={activeAccordion === 'general-info' ? 'active' : ''}
            eventKey={'general-info'}
        >
            <Accordion.Header>
                <img
                    src={GeneralInformationImage}
                    alt=""
                />
                <span>
                    {t('Company Information')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                 <Row className="g-3 mb-4">
                    <Col sm="12" md="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="me-2 text-primary">
                                        <RiBuilding4Line size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('General Information')}
                                    </div>
                                </div>
                                
                                <Row>
                                    {organizationData?.additional_information?.generic?.map((item, index) => {
                                        return (
                                            <GenericDataCol
                                                key={index}
                                                t={t}
                                                label={item.key}
                                                value={item.value}
                                            />
                                        )
                                    })}
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    GeneralInfo
)